/*
 * # Semantic UI
 * https://github.com/Semantic-Org/Semantic-UI
 * http://www.semantic-ui.com/
 *
 * Copyright 2014 Contributors
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */

const jQuery = require('jquery');
/*
 * # Semantic - Site
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Copyright 2014 Contributor
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
(function ($, window, document, undefined) {
  $.site = $.fn.site = function (parameters) {
    let time = new Date().getTime();
    let performance = [];
    const query = arguments[0];
    const methodInvoked = typeof query === 'string';
    const queryArguments = [].slice.call(arguments, 1);
    const settings = $.isPlainObject(parameters)
      ? $.extend(true, {}, $.site.settings, parameters)
      : $.extend({}, $.site.settings);
    const { namespace } = settings;
    const { error } = settings;
    const eventNamespace = `.${namespace}`;
    const moduleNamespace = `module-${namespace}`;
    const $document = $(document);
    const $module = $document;
    const element = this;
    let instance = $module.data(moduleNamespace);
    let module;
    let returnedValue;
    module = {
      initialize() {
        module.instantiate();
      },

      instantiate() {
        module.verbose('Storing instance of site', module);
        instance = module;
        $module.data(moduleNamespace, module);
      },

      normalize() {
        module.fix.console();
        module.fix.requestAnimationFrame();
      },

      fix: {
        console() {
          module.debug('Normalizing window.console');
          if (console === undefined || console.log === undefined) {
            module.verbose('Console not available, normalizing events');
            module.disable.console();
          }
          if (
            typeof console.group === 'undefined' ||
            typeof console.groupEnd === 'undefined' ||
            typeof console.groupCollapsed === 'undefined'
          ) {
            module.verbose('Console group not available, normalizing events');
            window.console.group = function () {};
            window.console.groupEnd = function () {};
            window.console.groupCollapsed = function () {};
          }
          if (typeof console.markTimeline === 'undefined') {
            module.verbose('Mark timeline not available, normalizing events');
            window.console.markTimeline = function () {};
          }
        },
        consoleClear() {
          module.debug('Disabling programmatic console clearing');
          window.console.clear = function () {};
        },
        requestAnimationFrame() {
          module.debug('Normalizing requestAnimationFrame');
          if (window.requestAnimationFrame === undefined) {
            module.debug(
              'RequestAnimationFrame not available, normailizing event'
            );
            window.requestAnimationFrame =
              window.requestAnimationFrame ||
              window.mozRequestAnimationFrame ||
              window.webkitRequestAnimationFrame ||
              window.msRequestAnimationFrame ||
              function (callback) {
                setTimeout(callback, 0);
              };
          }
        }
      },

      moduleExists(name) {
        return $.fn[name] !== undefined && $.fn[name].settings !== undefined;
      },

      enabled: {
        modules(modules) {
          const enabledModules = [];
          modules = modules || settings.modules;
          $.each(modules, function (index, name) {
            if (module.moduleExists(name)) {
              enabledModules.push(name);
            }
          });
          return enabledModules;
        }
      },

      disabled: {
        modules(modules) {
          const disabledModules = [];
          modules = modules || settings.modules;
          $.each(modules, function (index, name) {
            if (!module.moduleExists(name)) {
              disabledModules.push(name);
            }
          });
          return disabledModules;
        }
      },

      change: {
        setting(setting, value, modules, modifyExisting) {
          modules =
            typeof modules === 'string'
              ? modules === 'all'
                ? settings.modules
                : [modules]
              : modules || settings.modules;
          modifyExisting = modifyExisting !== undefined ? modifyExisting : true;
          $.each(modules, function (index, name) {
            const namespace = module.moduleExists(name)
              ? $.fn[name].settings.namespace || false
              : true;
            let $existingModules;
            if (module.moduleExists(name)) {
              module.verbose('Changing default setting', setting, value, name);
              $.fn[name].settings[setting] = value;
              if (modifyExisting && namespace) {
                $existingModules = $(`:data(module-${namespace})`);
                if ($existingModules.size() > 0) {
                  module.verbose(
                    'Modifying existing settings',
                    $existingModules
                  );
                  $existingModules[name]('setting', setting, value);
                }
              }
            }
          });
        },
        settings(newSettings, modules, modifyExisting) {
          modules =
            typeof modules === 'string'
              ? [modules]
              : modules || settings.modules;
          modifyExisting = modifyExisting !== undefined ? modifyExisting : true;
          $.each(modules, function (index, name) {
            let $existingModules;
            if (module.moduleExists(name)) {
              module.verbose('Changing default setting', newSettings, name);
              $.extend(true, $.fn[name].settings, newSettings);
              if (modifyExisting && namespace) {
                $existingModules = $(`:data(module-${namespace})`);
                if ($existingModules.size() > 0) {
                  module.verbose(
                    'Modifying existing settings',
                    $existingModules
                  );
                  $existingModules[name]('setting', newSettings);
                }
              }
            }
          });
        }
      },

      enable: {
        console() {
          module.console(true);
        },
        debug(modules, modifyExisting) {
          modules = modules || settings.modules;
          module.debug('Enabling debug for modules', modules);
          module.change.setting('debug', true, modules, modifyExisting);
        },
        verbose(modules, modifyExisting) {
          modules = modules || settings.modules;
          module.debug('Enabling verbose debug for modules', modules);
          module.change.setting('verbose', true, modules, modifyExisting);
        }
      },
      disable: {
        console() {
          module.console(false);
        },
        debug(modules, modifyExisting) {
          modules = modules || settings.modules;
          module.debug('Disabling debug for modules', modules);
          module.change.setting('debug', false, modules, modifyExisting);
        },
        verbose(modules, modifyExisting) {
          modules = modules || settings.modules;
          module.debug('Disabling verbose debug for modules', modules);
          module.change.setting('verbose', false, modules, modifyExisting);
        }
      },

      console(enable) {
        if (enable) {
          if (instance.cache.console === undefined) {
            module.error(error.console);
            return;
          }
          module.debug('Restoring console function');
          window.console = instance.cache.console;
        } else {
          module.debug('Disabling console function');
          instance.cache.console = window.console;
          window.console = {
            clear() {},
            error() {},
            group() {},
            groupCollapsed() {},
            groupEnd() {},
            info() {},
            log() {},
            markTimeline() {},
            warn() {}
          };
        }
      },

      destroy() {
        module.verbose('Destroying previous site for', $module);
        $module.removeData(moduleNamespace);
      },

      cache: {},

      setting(name, value) {
        if ($.isPlainObject(name)) {
          $.extend(true, settings, name);
        } else if (value !== undefined) {
          settings[name] = value;
        } else {
          return settings[name];
        }
      },
      internal(name, value) {
        if ($.isPlainObject(name)) {
          $.extend(true, module, name);
        } else if (value !== undefined) {
          module[name] = value;
        } else {
          return module[name];
        }
      },
      debug() {
        if (settings.debug) {
          if (settings.performance) {
            module.performance.log(arguments);
          } else {
            module.debug = Function.prototype.bind.call(
              console.info,
              console,
              `${settings.name}:`
            );
            module.debug.apply(console, arguments);
          }
        }
      },
      verbose() {
        if (settings.verbose && settings.debug) {
          if (settings.performance) {
            module.performance.log(arguments);
          } else {
            module.verbose = Function.prototype.bind.call(
              console.info,
              console,
              `${settings.name}:`
            );
            module.verbose.apply(console, arguments);
          }
        }
      },
      error() {
        module.error = Function.prototype.bind.call(
          console.error,
          console,
          `${settings.name}:`
        );
        module.error.apply(console, arguments);
      },
      performance: {
        log(message) {
          let currentTime;
          let executionTime;
          let previousTime;
          if (settings.performance) {
            currentTime = new Date().getTime();
            previousTime = time || currentTime;
            executionTime = currentTime - previousTime;
            time = currentTime;
            performance.push({
              Element: element,
              Name: message[0],
              Arguments: [].slice.call(message, 1) || '',
              'Execution Time': executionTime
            });
          }
          clearTimeout(module.performance.timer);
          module.performance.timer = setTimeout(
            module.performance.display,
            100
          );
        },
        display() {
          let title = `${settings.name}:`;
          let totalTime = 0;
          time = false;
          clearTimeout(module.performance.timer);
          $.each(performance, function (index, data) {
            totalTime += data['Execution Time'];
          });
          title += ` ${totalTime}ms`;
          if (
            (console.group !== undefined || console.table !== undefined) &&
            performance.length > 0
          ) {
            console.groupCollapsed(title);
            if (console.table) {
              console.table(performance);
            } else {
              $.each(performance, function (index, data) {
                console.log(`${data.Name}: ${data['Execution Time']}ms`);
              });
            }
            console.groupEnd();
          }
          performance = [];
        }
      },
      invoke(query, passedArguments, context) {
        let object = instance;
        let maxDepth;
        let found;
        let response;
        passedArguments = passedArguments || queryArguments;
        context = element || context;
        if (typeof query === 'string' && object !== undefined) {
          query = query.split(/[\. ]/);
          maxDepth = query.length - 1;
          $.each(query, function (depth, value) {
            const camelCaseValue =
              depth != maxDepth
                ? value +
                  query[depth + 1].charAt(0).toUpperCase() +
                  query[depth + 1].slice(1)
                : query;
            if ($.isPlainObject(object[camelCaseValue]) && depth != maxDepth) {
              object = object[camelCaseValue];
            } else if (object[camelCaseValue] !== undefined) {
              found = object[camelCaseValue];
              return false;
            } else if ($.isPlainObject(object[value]) && depth != maxDepth) {
              object = object[value];
            } else if (object[value] !== undefined) {
              found = object[value];
              return false;
            } else {
              module.error(error.method, query);
              return false;
            }
          });
        }
        if ($.isFunction(found)) {
          response = found.apply(context, passedArguments);
        } else if (found !== undefined) {
          response = found;
        }
        if ($.isArray(returnedValue)) {
          returnedValue.push(response);
        } else if (returnedValue !== undefined) {
          returnedValue = [returnedValue, response];
        } else if (response !== undefined) {
          returnedValue = response;
        }
        return found;
      }
    };

    if (methodInvoked) {
      if (instance === undefined) {
        module.initialize();
      }
      module.invoke(query);
    } else {
      if (instance !== undefined) {
        module.destroy();
      }
      module.initialize();
    }
    return returnedValue !== undefined ? returnedValue : this;
  };

  $.site.settings = {
    name: 'Site',
    namespace: 'site',

    error: {
      console:
        'Console cannot be restored, most likely it was overwritten outside of module',
      method: 'The method you called is not defined.'
    },

    debug: false,
    verbose: true,
    performance: true,

    modules: [
      'accordion',
      'api',
      'checkbox',
      'dimmer',
      'dropdown',
      'form',
      'modal',
      'nag',
      'popup',
      'rating',
      'shape',
      'sidebar',
      'state',
      'sticky',
      'tab',
      'transition',
      'video',
      'visit',
      'visibility'
    ],

    siteNamespace: 'site',
    namespaceStub: {
      cache: {},
      config: {},
      sections: {},
      section: {},
      utilities: {}
    }
  };

  // allows for selection of elements with data attributes
  $.extend($.expr[':'], {
    data: $.expr.createPseudo
      ? $.expr.createPseudo(function (dataName) {
          return function (elem) {
            return !!$.data(elem, dataName);
          };
        })
      : function (elem, i, match) {
          // support: jQuery < 1.8
          return !!$.data(elem, match[3]);
        }
  });
})(jQuery, window, document);
/*
 * # Semantic - Checkbox
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Copyright 2014 Contributor
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */

(function ($, window, document, undefined) {
  $.fn.checkbox = function (parameters) {
    const $allModules = $(this);
    const moduleSelector = $allModules.selector || '';
    let time = new Date().getTime();
    let performance = [];
    const query = arguments[0];
    const methodInvoked = typeof query === 'string';
    const queryArguments = [].slice.call(arguments, 1);
    let returnedValue;

    $allModules.each(function () {
      const settings = $.extend(true, {}, $.fn.checkbox.settings, parameters);
      const { className } = settings;
      const { namespace } = settings;
      const { selector } = settings;
      const { error } = settings;
      const eventNamespace = `.${namespace}`;
      const moduleNamespace = `module-${namespace}`;
      let $module = $(this);
      let $label = $(this).find(selector.label).first();
      let $input = $(this).find(selector.input);
      let instance = $module.data(moduleNamespace);
      let observer;
      const element = this;
      let module;

      module = {
        initialize() {
          module.verbose('Initializing checkbox', settings);

          module.create.label();
          module.add.events();

          if (module.is.checked()) {
            module.set.checked();
            if (settings.fireOnInit) {
              $.proxy(settings.onChecked, $input.get())();
            }
          } else {
            module.remove.checked();
            if (settings.fireOnInit) {
              $.proxy(settings.onUnchecked, $input.get())();
            }
          }
          module.observeChanges();

          module.instantiate();
        },

        instantiate() {
          module.verbose('Storing instance of module', module);
          instance = module;
          $module.data(moduleNamespace, module);
        },

        destroy() {
          module.verbose('Destroying module');
          module.remove.events();
          $module.removeData(moduleNamespace);
        },

        refresh() {
          $module = $(this);
          $label = $(this).find(selector.label).first();
          $input = $(this).find(selector.input);
        },

        observeChanges() {
          if ('MutationObserver' in window) {
            observer = new MutationObserver(function (mutations) {
              module.debug('DOM tree modified, updating selector cache');
              module.refresh();
            });
            observer.observe(element, {
              childList: true,
              subtree: true
            });
            module.debug('Setting up mutation observer', observer);
          }
        },

        attachEvents(selector, event) {
          const $element = $(selector);
          event = $.isFunction(module[event]) ? module[event] : module.toggle;
          if ($element.size() > 0) {
            module.debug(
              'Attaching checkbox events to element',
              selector,
              event
            );
            $element.on(`click${eventNamespace}`, event);
          } else {
            module.error(error.notFound);
          }
        },

        event: {
          keydown(event) {
            const key = event.which;
            const keyCode = {
              enter: 13,
              escape: 27
            };
            if (key == keyCode.escape) {
              module.verbose('Escape key pressed blurring field');
              $module.blur();
            }
            if (!event.ctrlKey && key == keyCode.enter) {
              module.verbose('Enter key pressed, toggling checkbox');
              $.proxy(module.toggle, this)();
              event.preventDefault();
            }
          }
        },

        is: {
          radio() {
            return $module.hasClass(className.radio);
          },
          checked() {
            return (
              $input.prop('checked') !== undefined && $input.prop('checked')
            );
          },
          unchecked() {
            return !module.is.checked();
          }
        },

        can: {
          change() {
            return !(
              $module.hasClass(className.disabled) ||
              $module.hasClass(className.readOnly) ||
              $input.prop('disabled')
            );
          },
          uncheck() {
            return typeof settings.uncheckable === 'boolean'
              ? settings.uncheckable
              : !module.is.radio();
          }
        },

        set: {
          checked() {
            $module.addClass(className.checked);
          },
          tab() {
            if ($input.attr('tabindex') === undefined) {
              $input.attr('tabindex', 0);
            }
          }
        },

        create: {
          label() {
            if ($input.prevAll(selector.label).size() > 0) {
              $input.prev(selector.label).detach().insertAfter($input);
              module.debug('Moving existing label', $label);
            } else if (!module.has.label()) {
              $label = $('<label>').insertAfter($input);
              module.debug('Creating label', $label);
            }
          }
        },

        has: {
          label() {
            return $label.size() > 0;
          }
        },

        add: {
          events() {
            module.verbose('Attaching checkbox events');
            $module
              .on(`click${eventNamespace}`, module.toggle)
              .on(
                `keydown${eventNamespace}`,
                selector.input,
                module.event.keydown
              );
          }
        },

        remove: {
          checked() {
            $module.removeClass(className.checked);
          },
          events() {
            module.debug('Removing events');
            $module.off(eventNamespace).removeData(moduleNamespace);
            $input.off(eventNamespace, module.event.keydown);
            $label.off(eventNamespace);
          }
        },

        enable() {
          module.debug('Enabling checkbox functionality');
          $module.removeClass(className.disabled);
          $input.prop('disabled', false);
          $.proxy(settings.onEnabled, $input.get())();
        },

        disable() {
          module.debug('Disabling checkbox functionality');
          $module.addClass(className.disabled);
          $input.prop('disabled', 'disabled');
          $.proxy(settings.onDisabled, $input.get())();
        },

        check() {
          module.debug('Enabling checkbox', $input);
          $input.prop('checked', true).trigger('change');
          module.set.checked();
          $.proxy(settings.onChange, $input.get())();
          $.proxy(settings.onChecked, $input.get())();
        },

        uncheck() {
          module.debug('Disabling checkbox');
          $input.prop('checked', false).trigger('change');
          module.remove.checked();
          $.proxy(settings.onChange, $input.get())();
          $.proxy(settings.onUnchecked, $input.get())();
        },

        toggle(event) {
          if (!module.can.change()) {
            console.log(module.can.change());
            module.debug('Checkbox is read-only or disabled, ignoring toggle');
            return;
          }
          module.verbose('Determining new checkbox state');
          if (module.is.unchecked()) {
            module.check();
          } else if (module.is.checked() && module.can.uncheck()) {
            module.uncheck();
          }
        },
        setting(name, value) {
          module.debug('Changing setting', name, value);
          if ($.isPlainObject(name)) {
            $.extend(true, settings, name);
          } else if (value !== undefined) {
            settings[name] = value;
          } else {
            return settings[name];
          }
        },
        internal(name, value) {
          if ($.isPlainObject(name)) {
            $.extend(true, module, name);
          } else if (value !== undefined) {
            module[name] = value;
          } else {
            return module[name];
          }
        },
        debug() {
          if (settings.debug) {
            if (settings.performance) {
              module.performance.log(arguments);
            } else {
              module.debug = Function.prototype.bind.call(
                console.info,
                console,
                `${settings.name}:`
              );
              module.debug.apply(console, arguments);
            }
          }
        },
        verbose() {
          if (settings.verbose && settings.debug) {
            if (settings.performance) {
              module.performance.log(arguments);
            } else {
              module.verbose = Function.prototype.bind.call(
                console.info,
                console,
                `${settings.name}:`
              );
              module.verbose.apply(console, arguments);
            }
          }
        },
        error() {
          module.error = Function.prototype.bind.call(
            console.error,
            console,
            `${settings.name}:`
          );
          module.error.apply(console, arguments);
        },
        performance: {
          log(message) {
            let currentTime;
            let executionTime;
            let previousTime;
            if (settings.performance) {
              currentTime = new Date().getTime();
              previousTime = time || currentTime;
              executionTime = currentTime - previousTime;
              time = currentTime;
              performance.push({
                Name: message[0],
                Arguments: [].slice.call(message, 1) || '',
                Element: element,
                'Execution Time': executionTime
              });
            }
            clearTimeout(module.performance.timer);
            module.performance.timer = setTimeout(
              module.performance.display,
              100
            );
          },
          display() {
            let title = `${settings.name}:`;
            let totalTime = 0;
            time = false;
            clearTimeout(module.performance.timer);
            $.each(performance, function (index, data) {
              totalTime += data['Execution Time'];
            });
            title += ` ${totalTime}ms`;
            if (moduleSelector) {
              title += ` '${moduleSelector}'`;
            }
            if (
              (console.group !== undefined || console.table !== undefined) &&
              performance.length > 0
            ) {
              console.groupCollapsed(title);
              if (console.table) {
                console.table(performance);
              } else {
                $.each(performance, function (index, data) {
                  console.log(`${data.Name}: ${data['Execution Time']}ms`);
                });
              }
              console.groupEnd();
            }
            performance = [];
          }
        },
        invoke(query, passedArguments, context) {
          let object = instance;
          let maxDepth;
          let found;
          let response;
          passedArguments = passedArguments || queryArguments;
          context = element || context;
          if (typeof query === 'string' && object !== undefined) {
            query = query.split(/[\. ]/);
            maxDepth = query.length - 1;
            $.each(query, function (depth, value) {
              const camelCaseValue =
                depth != maxDepth
                  ? value +
                    query[depth + 1].charAt(0).toUpperCase() +
                    query[depth + 1].slice(1)
                  : query;
              if (
                $.isPlainObject(object[camelCaseValue]) &&
                depth != maxDepth
              ) {
                object = object[camelCaseValue];
              } else if (object[camelCaseValue] !== undefined) {
                found = object[camelCaseValue];
                return false;
              } else if ($.isPlainObject(object[value]) && depth != maxDepth) {
                object = object[value];
              } else if (object[value] !== undefined) {
                found = object[value];
                return false;
              } else {
                return false;
              }
            });
          }
          if ($.isFunction(found)) {
            response = found.apply(context, passedArguments);
          } else if (found !== undefined) {
            response = found;
          }
          if ($.isArray(returnedValue)) {
            returnedValue.push(response);
          } else if (returnedValue !== undefined) {
            returnedValue = [returnedValue, response];
          } else if (response !== undefined) {
            returnedValue = response;
          }
          return found;
        }
      };

      if (methodInvoked) {
        if (instance === undefined) {
          module.initialize();
        }
        module.invoke(query);
      } else {
        if (instance !== undefined) {
          module.destroy();
        }
        module.initialize();
      }
    });

    return returnedValue !== undefined ? returnedValue : this;
  };

  $.fn.checkbox.settings = {
    name: 'Checkbox',
    namespace: 'checkbox',

    debug: false,
    verbose: true,
    performance: true,

    // delegated event context
    uncheckable: 'auto',
    fireOnInit: true,

    onChange() {},
    onChecked() {},
    onUnchecked() {},
    onEnabled() {},
    onDisabled() {},

    className: {
      checked: 'checked',
      disabled: 'disabled',
      radio: 'radio',
      readOnly: 'read-only'
    },

    error: {
      method: 'The method you called is not defined.'
    },

    selector: {
      input: 'input[type=checkbox], input[type=radio]',
      label: 'label'
    }
  };
})(jQuery, window, document);

/*
 * # Semantic - Shape
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Copyright 2014 Contributor
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */

(function ($, window, document, undefined) {
  $.fn.shape = function (parameters) {
    const $allModules = $(this);
    const $body = $('body');
    let time = new Date().getTime();
    let performance = [];
    const query = arguments[0];
    const methodInvoked = typeof query === 'string';
    const queryArguments = [].slice.call(arguments, 1);
    const requestAnimationFrame =
      window.requestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      window.msRequestAnimationFrame ||
      function (callback) {
        setTimeout(callback, 0);
      };
    let returnedValue;

    $allModules.each(function () {
      const moduleSelector = $allModules.selector || '';
      const settings = $.extend(true, {}, $.fn.shape.settings, parameters);
      // internal aliases
      const { namespace } = settings;
      const { selector } = settings;
      const { error } = settings;
      const { className } = settings;
      // define namespaces for modules
      const eventNamespace = `.${namespace}`;
      const moduleNamespace = `module-${namespace}`;
      // selector cache
      let $module = $(this);
      let $sides = $module.find(selector.sides);
      let $side = $module.find(selector.side);
      // private variables
      let nextIndex = false;
      let $activeSide;
      let $nextSide;
      // standard module
      const element = this;
      let instance = $module.data(moduleNamespace);
      let module;

      module = {
        initialize() {
          module.verbose('Initializing module for', element);
          module.set.defaultSide();
          module.instantiate();
        },

        instantiate() {
          module.verbose('Storing instance of module', module);
          instance = module;
          $module.data(moduleNamespace, instance);
        },

        destroy() {
          module.verbose('Destroying previous module for', element);
          $module.removeData(moduleNamespace).off(eventNamespace);
        },

        refresh() {
          module.verbose('Refreshing selector cache for', element);
          $module = $(element);
          $sides = $(this).find(selector.shape);
          $side = $(this).find(selector.side);
        },

        repaint() {
          module.verbose('Forcing repaint event');
          const shape = $sides.get(0) || document.createElement('div');
          const fakeAssignment = shape.offsetWidth;
        },

        animate(propertyObject, callback) {
          module.verbose('Animating box with properties', propertyObject);
          callback =
            callback ||
            function (event) {
              module.verbose('Executing animation callback');
              if (event !== undefined) {
                event.stopPropagation();
              }
              module.reset();
              module.set.active();
            };
          $.proxy(settings.beforeChange, $nextSide[0])();
          if (module.get.transitionEvent()) {
            module.verbose('Starting CSS animation');
            $module.addClass(className.animating);
            $sides
              .css(propertyObject)
              .one(module.get.transitionEvent(), callback);
            module.set.duration(settings.duration);
            requestAnimationFrame(function () {
              $module.addClass(className.animating);
              $activeSide.addClass(className.hidden);
            });
          } else {
            callback();
          }
        },

        queue(method) {
          module.debug('Queueing animation of', method);
          $sides.one(module.get.transitionEvent(), function () {
            module.debug('Executing queued animation');
            setTimeout(function () {
              $module.shape(method);
            }, 0);
          });
        },

        reset() {
          module.verbose('Animating states reset');
          $module
            .removeClass(className.animating)
            .attr('style', '')
            .removeAttr('style');
          // removeAttr style does not consistently work in safari
          $sides.attr('style', '').removeAttr('style');
          $side
            .attr('style', '')
            .removeAttr('style')
            .removeClass(className.hidden);
          $nextSide
            .removeClass(className.animating)
            .attr('style', '')
            .removeAttr('style');
        },

        is: {
          complete() {
            return $side.filter(`.${className.active}`)[0] == $nextSide[0];
          },
          animating() {
            return $module.hasClass(className.animating);
          }
        },

        set: {
          defaultSide() {
            $activeSide = $module.find(`.${settings.className.active}`);
            $nextSide =
              $activeSide.next(selector.side).size() > 0
                ? $activeSide.next(selector.side)
                : $module.find(selector.side).first();
            nextIndex = false;
            module.verbose('Active side set to', $activeSide);
            module.verbose('Next side set to', $nextSide);
          },

          duration(duration) {
            duration = duration || settings.duration;
            duration =
              typeof duration === 'number' ? `${duration}ms` : duration;
            module.verbose('Setting animation duration', duration);
            $sides.add($side).css({
              '-webkit-transition-duration': duration,
              '-moz-transition-duration': duration,
              '-ms-transition-duration': duration,
              '-o-transition-duration': duration,
              'transition-duration': duration
            });
          },

          stageSize() {
            const $clone = $module.clone().addClass(className.loading);
            const $activeSide = $clone.find(`.${settings.className.active}`);
            const $nextSide = nextIndex
              ? $clone.find(selector.side).eq(nextIndex)
              : $activeSide.next(selector.side).size() > 0
              ? $activeSide.next(selector.side)
              : $clone.find(selector.side).first();
            let newSize = {};
            $activeSide.removeClass(className.active);
            $nextSide.addClass(className.active);
            $clone.insertAfter($module);
            newSize = {
              width: $nextSide.outerWidth(),
              height: $nextSide.outerHeight()
            };
            $clone.remove();
            $module.css(newSize);
            module.verbose('Resizing stage to fit new content', newSize);
          },

          nextSide(selector) {
            nextIndex = selector;
            $nextSide = $side.filter(selector);
            nextIndex = $side.index($nextSide);
            if ($nextSide.size() === 0) {
              module.set.defaultSide();
              module.error(error.side);
            }
            module.verbose('Next side manually set to', $nextSide);
          },

          active() {
            module.verbose('Setting new side to active', $nextSide);
            $side.removeClass(className.active);
            $nextSide.addClass(className.active);
            $.proxy(settings.onChange, $nextSide[0])();
            module.set.defaultSide();
          }
        },

        flip: {
          up() {
            if (
              module.is.complete() &&
              !module.is.animating() &&
              !settings.allowRepeats
            ) {
              module.debug('Side already visible', $nextSide);
              return;
            }
            if (!module.is.animating()) {
              module.debug('Flipping up', $nextSide);
              module.set.stageSize();
              module.stage.above();
              module.animate(module.get.transform.up());
            } else {
              module.queue('flip up');
            }
          },

          down() {
            if (
              module.is.complete() &&
              !module.is.animating() &&
              !settings.allowRepeats
            ) {
              module.debug('Side already visible', $nextSide);
              return;
            }
            if (!module.is.animating()) {
              module.debug('Flipping down', $nextSide);
              module.set.stageSize();
              module.stage.below();
              module.animate(module.get.transform.down());
            } else {
              module.queue('flip down');
            }
          },

          left() {
            if (
              module.is.complete() &&
              !module.is.animating() &&
              !settings.allowRepeats
            ) {
              module.debug('Side already visible', $nextSide);
              return;
            }
            if (!module.is.animating()) {
              module.debug('Flipping left', $nextSide);
              module.set.stageSize();
              module.stage.left();
              module.animate(module.get.transform.left());
            } else {
              module.queue('flip left');
            }
          },

          right() {
            if (
              module.is.complete() &&
              !module.is.animating() &&
              !settings.allowRepeats
            ) {
              module.debug('Side already visible', $nextSide);
              return;
            }
            if (!module.is.animating()) {
              module.debug('Flipping right', $nextSide);
              module.set.stageSize();
              module.stage.right();
              module.animate(module.get.transform.right());
            } else {
              module.queue('flip right');
            }
          },

          over() {
            if (
              module.is.complete() &&
              !module.is.animating() &&
              !settings.allowRepeats
            ) {
              module.debug('Side already visible', $nextSide);
              return;
            }
            if (!module.is.animating()) {
              module.debug('Flipping over', $nextSide);
              module.set.stageSize();
              module.stage.behind();
              module.animate(module.get.transform.over());
            } else {
              module.queue('flip over');
            }
          },

          back() {
            if (
              module.is.complete() &&
              !module.is.animating() &&
              !settings.allowRepeats
            ) {
              module.debug('Side already visible', $nextSide);
              return;
            }
            if (!module.is.animating()) {
              module.debug('Flipping back', $nextSide);
              module.set.stageSize();
              module.stage.behind();
              module.animate(module.get.transform.back());
            } else {
              module.queue('flip back');
            }
          }
        },

        get: {
          transform: {
            up() {
              const translate = {
                y: -(($activeSide.outerHeight() - $nextSide.outerHeight()) / 2),
                z: -($activeSide.outerHeight() / 2)
              };
              return {
                transform: `translateY(${translate.y}px) translateZ(${translate.z}px) rotateX(-90deg)`
              };
            },

            down() {
              const translate = {
                y: -(($activeSide.outerHeight() - $nextSide.outerHeight()) / 2),
                z: -($activeSide.outerHeight() / 2)
              };
              return {
                transform: `translateY(${translate.y}px) translateZ(${translate.z}px) rotateX(90deg)`
              };
            },

            left() {
              const translate = {
                x: -(($activeSide.outerWidth() - $nextSide.outerWidth()) / 2),
                z: -($activeSide.outerWidth() / 2)
              };
              return {
                transform: `translateX(${translate.x}px) translateZ(${translate.z}px) rotateY(90deg)`
              };
            },

            right() {
              const translate = {
                x: -(($activeSide.outerWidth() - $nextSide.outerWidth()) / 2),
                z: -($activeSide.outerWidth() / 2)
              };
              return {
                transform: `translateX(${translate.x}px) translateZ(${translate.z}px) rotateY(-90deg)`
              };
            },

            over() {
              const translate = {
                x: -(($activeSide.outerWidth() - $nextSide.outerWidth()) / 2)
              };
              return {
                transform: `translateX(${translate.x}px) rotateY(180deg)`
              };
            },

            back() {
              const translate = {
                x: -(($activeSide.outerWidth() - $nextSide.outerWidth()) / 2)
              };
              return {
                transform: `translateX(${translate.x}px) rotateY(-180deg)`
              };
            }
          },

          transitionEvent() {
            const element = document.createElement('element');
            const transitions = {
              transition: 'transitionend',
              OTransition: 'oTransitionEnd',
              MozTransition: 'transitionend',
              WebkitTransition: 'webkitTransitionEnd'
            };
            let transition;
            for (transition in transitions) {
              if (element.style[transition] !== undefined) {
                return transitions[transition];
              }
            }
          },

          nextSide() {
            return $activeSide.next(selector.side).size() > 0
              ? $activeSide.next(selector.side)
              : $module.find(selector.side).first();
          }
        },

        stage: {
          above() {
            const box = {
              origin: ($activeSide.outerHeight() - $nextSide.outerHeight()) / 2,
              depth: {
                active: $nextSide.outerHeight() / 2,
                next: $activeSide.outerHeight() / 2
              }
            };
            module.verbose(
              'Setting the initial animation position as above',
              $nextSide,
              box
            );
            $activeSide.css({
              transform: `rotateY(0deg) translateZ(${box.depth.active}px)`
            });
            $nextSide.addClass(className.animating).css({
              display: 'block',
              top: `${box.origin}px`,
              transform: `rotateX(90deg) translateZ(${box.depth.next}px)`
            });
          },

          below() {
            const box = {
              origin: ($activeSide.outerHeight() - $nextSide.outerHeight()) / 2,
              depth: {
                active: $nextSide.outerHeight() / 2,
                next: $activeSide.outerHeight() / 2
              }
            };
            module.verbose(
              'Setting the initial animation position as below',
              $nextSide,
              box
            );
            $activeSide.css({
              transform: `rotateY(0deg) translateZ(${box.depth.active}px)`
            });
            $nextSide.addClass(className.animating).css({
              display: 'block',
              top: `${box.origin}px`,
              transform: `rotateX(-90deg) translateZ(${box.depth.next}px)`
            });
          },

          left() {
            const box = {
              origin: ($activeSide.outerWidth() - $nextSide.outerWidth()) / 2,
              depth: {
                active: $nextSide.outerWidth() / 2,
                next: $activeSide.outerWidth() / 2
              }
            };
            module.verbose(
              'Setting the initial animation position as left',
              $nextSide,
              box
            );
            $activeSide.css({
              transform: `rotateY(0deg) translateZ(${box.depth.active}px)`
            });
            $nextSide.addClass(className.animating).css({
              display: 'block',
              left: `${box.origin}px`,
              transform: `rotateY(-90deg) translateZ(${box.depth.next}px)`
            });
          },

          right() {
            const box = {
              origin: ($activeSide.outerWidth() - $nextSide.outerWidth()) / 2,
              depth: {
                active: $nextSide.outerWidth() / 2,
                next: $activeSide.outerWidth() / 2
              }
            };
            module.verbose(
              'Setting the initial animation position as left',
              $nextSide,
              box
            );
            $activeSide.css({
              transform: `rotateY(0deg) translateZ(${box.depth.active}px)`
            });
            $nextSide.addClass(className.animating).css({
              display: 'block',
              left: `${box.origin}px`,
              transform: `rotateY(90deg) translateZ(${box.depth.next}px)`
            });
          },

          behind() {
            const box = {
              origin: ($activeSide.outerWidth() - $nextSide.outerWidth()) / 2,
              depth: {
                active: $nextSide.outerWidth() / 2,
                next: $activeSide.outerWidth() / 2
              }
            };
            module.verbose(
              'Setting the initial animation position as behind',
              $nextSide,
              box
            );
            $activeSide.css({
              transform: 'rotateY(0deg)'
            });
            $nextSide.addClass(className.animating).css({
              display: 'block',
              left: `${box.origin}px`,
              transform: 'rotateY(-180deg)'
            });
          }
        },
        setting(name, value) {
          module.debug('Changing setting', name, value);
          if ($.isPlainObject(name)) {
            $.extend(true, settings, name);
          } else if (value !== undefined) {
            settings[name] = value;
          } else {
            return settings[name];
          }
        },
        internal(name, value) {
          if ($.isPlainObject(name)) {
            $.extend(true, module, name);
          } else if (value !== undefined) {
            module[name] = value;
          } else {
            return module[name];
          }
        },
        debug() {
          if (settings.debug) {
            if (settings.performance) {
              module.performance.log(arguments);
            } else {
              module.debug = Function.prototype.bind.call(
                console.info,
                console,
                `${settings.name}:`
              );
              module.debug.apply(console, arguments);
            }
          }
        },
        verbose() {
          if (settings.verbose && settings.debug) {
            if (settings.performance) {
              module.performance.log(arguments);
            } else {
              module.verbose = Function.prototype.bind.call(
                console.info,
                console,
                `${settings.name}:`
              );
              module.verbose.apply(console, arguments);
            }
          }
        },
        error() {
          module.error = Function.prototype.bind.call(
            console.error,
            console,
            `${settings.name}:`
          );
          module.error.apply(console, arguments);
        },
        performance: {
          log(message) {
            let currentTime;
            let executionTime;
            let previousTime;
            if (settings.performance) {
              currentTime = new Date().getTime();
              previousTime = time || currentTime;
              executionTime = currentTime - previousTime;
              time = currentTime;
              performance.push({
                Name: message[0],
                Arguments: [].slice.call(message, 1) || '',
                Element: element,
                'Execution Time': executionTime
              });
            }
            clearTimeout(module.performance.timer);
            module.performance.timer = setTimeout(
              module.performance.display,
              100
            );
          },
          display() {
            let title = `${settings.name}:`;
            let totalTime = 0;
            time = false;
            clearTimeout(module.performance.timer);
            $.each(performance, function (index, data) {
              totalTime += data['Execution Time'];
            });
            title += ` ${totalTime}ms`;
            if (moduleSelector) {
              title += ` '${moduleSelector}'`;
            }
            if ($allModules.size() > 1) {
              title += `${' ' + '('}${$allModules.size()})`;
            }
            if (
              (console.group !== undefined || console.table !== undefined) &&
              performance.length > 0
            ) {
              console.groupCollapsed(title);
              if (console.table) {
                console.table(performance);
              } else {
                $.each(performance, function (index, data) {
                  console.log(`${data.Name}: ${data['Execution Time']}ms`);
                });
              }
              console.groupEnd();
            }
            performance = [];
          }
        },
        invoke(query, passedArguments, context) {
          let object = instance;
          let maxDepth;
          let found;
          let response;
          passedArguments = passedArguments || queryArguments;
          context = element || context;
          if (typeof query === 'string' && object !== undefined) {
            query = query.split(/[\. ]/);
            maxDepth = query.length - 1;
            $.each(query, function (depth, value) {
              const camelCaseValue =
                depth != maxDepth
                  ? value +
                    query[depth + 1].charAt(0).toUpperCase() +
                    query[depth + 1].slice(1)
                  : query;
              if (
                $.isPlainObject(object[camelCaseValue]) &&
                depth != maxDepth
              ) {
                object = object[camelCaseValue];
              } else if (object[camelCaseValue] !== undefined) {
                found = object[camelCaseValue];
                return false;
              } else if ($.isPlainObject(object[value]) && depth != maxDepth) {
                object = object[value];
              } else if (object[value] !== undefined) {
                found = object[value];
                return false;
              } else {
                return false;
              }
            });
          }
          if ($.isFunction(found)) {
            response = found.apply(context, passedArguments);
          } else if (found !== undefined) {
            response = found;
          }
          if ($.isArray(returnedValue)) {
            returnedValue.push(response);
          } else if (returnedValue !== undefined) {
            returnedValue = [returnedValue, response];
          } else if (response !== undefined) {
            returnedValue = response;
          }
          return found;
        }
      };

      if (methodInvoked) {
        if (instance === undefined) {
          module.initialize();
        }
        module.invoke(query);
      } else {
        if (instance !== undefined) {
          module.destroy();
        }
        module.initialize();
      }
    });

    return returnedValue !== undefined ? returnedValue : this;
  };

  $.fn.shape.settings = {
    // module info
    name: 'Shape',

    // debug content outputted to console
    debug: false,

    // verbose debug output
    verbose: true,

    // performance data output
    performance: true,

    // event namespace
    namespace: 'shape',

    // callback occurs on side change
    beforeChange() {},
    onChange() {},

    // allow animation to same side
    allowRepeats: false,

    // animation duration
    duration: 700,

    // possible errors
    error: {
      side: 'You tried to switch to a side that does not exist.',
      method: 'The method you called is not defined'
    },

    // classnames used
    className: {
      animating: 'animating',
      hidden: 'hidden',
      loading: 'loading',
      active: 'active'
    },

    // selectors used
    selector: {
      sides: '.sides',
      side: '.side'
    }
  };
})(jQuery, window, document);
/*
 * # Semantic - Transition
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Copyright 2014 Contributor
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */

(function ($, window, document, undefined) {
  $.fn.transition = function () {
    const $allModules = $(this);
    const moduleSelector = $allModules.selector || '';
    let time = new Date().getTime();
    let performance = [];
    const moduleArguments = arguments;
    const query = moduleArguments[0];
    const queryArguments = [].slice.call(arguments, 1);
    let methodInvoked = typeof query === 'string';
    const requestAnimationFrame =
      window.requestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      window.msRequestAnimationFrame ||
      function (callback) {
        setTimeout(callback, 0);
      };
    let returnedValue;
    $allModules.each(function () {
      const $module = $(this);
      const element = this;
      // set at run time
      let settings;
      let instance;
      let error;
      let className;
      let metadata;
      let animationStart;
      let animationEnd;
      let animationName;
      let namespace;
      let moduleNamespace;
      let eventNamespace;
      let module;

      module = {
        initialize() {
          // get full settings
          moduleNamespace = `module-${namespace}`;
          settings = module.get.settings.apply(element, moduleArguments);
          className = settings.className;
          metadata = settings.metadata;

          animationStart = module.get.animationStartEvent();
          animationEnd = module.get.animationEndEvent();
          animationName = module.get.animationName();
          error = settings.error;
          namespace = settings.namespace;
          eventNamespace = `.${settings.namespace}`;
          instance = $module.data(moduleNamespace) || module;

          if (methodInvoked) {
            methodInvoked = module.invoke(query);
          }
          // no internal method was found matching query or query not made
          if (methodInvoked === false) {
            module.verbose(
              'Converted arguments into settings object',
              settings
            );
            module.animate();
            module.instantiate();
          }
        },

        instantiate() {
          module.verbose('Storing instance of module', module);
          $module.data(moduleNamespace, instance);
        },

        destroy() {
          module.verbose('Destroying previous module for', element);
          $module.removeData(moduleNamespace);
        },

        refresh() {
          module.verbose('Refreshing display type on next animation');
          delete module.displayType;
        },

        forceRepaint() {
          module.verbose('Forcing element repaint');
          const $parentElement = $module.parent();
          const $nextElement = $module.next();
          if ($nextElement.size() === 0) {
            $module.detach().appendTo($parentElement);
          } else {
            $module.detach().insertBefore($nextElement);
          }
        },

        repaint() {
          module.verbose('Repainting element');
          const fakeAssignment = element.offsetWidth;
        },

        animate(overrideSettings) {
          settings = overrideSettings || settings;
          if (!module.is.supported()) {
            module.error(error.support);
            return false;
          }
          module.debug('Preparing animation', settings.animation);
          if (module.is.animating()) {
            if (settings.queue) {
              if (
                !settings.allowRepeats &&
                module.has.direction() &&
                module.is.occuring() &&
                module.queuing !== true
              ) {
                module.error(error.repeated, settings.animation, $module);
              } else {
                module.queue(settings.animation);
              }
              return false;
            }
          }
          if (module.can.animate()) {
            module.set.animating(settings.animation);
          } else {
            module.error(error.noAnimation, settings.animation);
          }
        },

        reset() {
          module.debug('Resetting animation to beginning conditions');
          module.remove.animationEndCallback();
          module.restore.conditions();
          module.remove.animating();
        },

        queue(animation) {
          module.debug('Queueing animation of', animation);
          module.queuing = true;
          $module.one(animationEnd + eventNamespace, function () {
            module.queuing = false;
            module.repaint();
            module.animate.apply(this, settings);
          });
        },

        complete() {
          module.verbose('CSS animation complete', settings.animation);
          module.remove.animationEndCallback();
          module.remove.failSafe();
          if (!module.is.looping()) {
            if (module.is.outward()) {
              module.verbose('Animation is outward, hiding element');
              module.restore.conditions();
              module.hide();
              $.proxy(settings.onHide, this)();
            } else if (module.is.inward()) {
              module.verbose('Animation is outward, showing element');
              module.restore.conditions();
              module.show();
              module.set.display();
              $.proxy(settings.onShow, this)();
            } else {
              module.restore.conditions();
            }
            module.remove.animation();
            module.remove.animating();
          }
          $.proxy(settings.onComplete, this)();
        },

        has: {
          direction(animation) {
            animation = animation || settings.animation;
            if (
              animation.search(className.inward) !== -1 ||
              animation.search(className.outward) !== -1
            ) {
              module.debug('Direction already set in animation');
              return true;
            }
            return false;
          },
          inlineDisplay() {
            const style = $module.attr('style') || '';
            return $.isArray(style.match(/display.*?;/, ''));
          }
        },

        set: {
          animating(animation) {
            animation = animation || settings.animation;
            if (!module.is.animating()) {
              module.save.conditions();
            }
            module.remove.direction();
            module.remove.animationEndCallback();
            if (module.can.transition() && !module.has.direction()) {
              module.set.direction();
            }
            module.remove.hidden();
            module.set.display();
            $module
              .addClass(className.animating)
              .addClass(className.transition)
              .addClass(animation)
              .one(
                `${animationEnd}.complete${eventNamespace}`,
                module.complete
              );
            if (settings.useFailSafe) {
              module.add.failSafe();
            }
            module.set.duration(settings.duration);
            $.proxy(settings.onStart, this)();
            module.debug('Starting tween', animation, $module.attr('class'));
          },
          duration(animationName, duration) {
            duration = duration || settings.duration;
            duration =
              typeof duration === 'number' ? `${duration}ms` : duration;
            module.verbose('Setting animation duration', duration);
            $module.css({
              '-webkit-animation-duration': duration,
              '-moz-animation-duration': duration,
              '-ms-animation-duration': duration,
              '-o-animation-duration': duration,
              'animation-duration': duration
            });
          },
          display() {
            const style = module.get.style();
            const displayType = module.get.displayType();
            const overrideStyle = `${style}display: ${displayType} !important;`;
            $module.css('display', '');
            module.refresh();
            if ($module.css('display') !== displayType) {
              module.verbose('Setting inline visibility to', displayType);
              $module.attr('style', overrideStyle);
            }
          },
          direction() {
            if ($module.is(':visible') && !module.is.hidden()) {
              module.debug(
                'Automatically determining the direction of animation',
                'Outward'
              );
              $module.removeClass(className.inward).addClass(className.outward);
            } else {
              module.debug(
                'Automatically determining the direction of animation',
                'Inward'
              );
              $module.removeClass(className.outward).addClass(className.inward);
            }
          },
          looping() {
            module.debug('Transition set to loop');
            $module.addClass(className.looping);
          },
          hidden() {
            if (!module.is.hidden()) {
              $module.addClass(className.transition).addClass(className.hidden);
              if ($module.css('display') !== 'none') {
                module.verbose('Overriding default display to hide element');
                $module.css('display', 'none');
              }
            }
          },
          visible() {
            $module.addClass(className.transition).addClass(className.visible);
          }
        },

        save: {
          displayType(displayType) {
            $module.data(metadata.displayType, displayType);
          },
          transitionExists(animation, exists) {
            $.fn.transition.exists[animation] = exists;
            module.verbose('Saving existence of transition', animation, exists);
          },
          conditions() {
            const clasName = $module.attr('class') || false;
            const style = $module.attr('style') || '';
            $module.removeClass(settings.animation);
            module.remove.direction();
            module.cache = {
              className: $module.attr('class'),
              style: module.get.style()
            };
            module.verbose('Saving original attributes', module.cache);
          }
        },

        restore: {
          conditions() {
            if (module.cache === undefined) {
              return false;
            }
            if (module.cache.className) {
              $module.attr('class', module.cache.className);
            } else {
              $module.removeAttr('class');
            }
            if (module.cache.style) {
              module.verbose(
                'Restoring original style attribute',
                module.cache.style
              );
              $module.attr('style', module.cache.style);
            }
            if (module.is.looping()) {
              module.remove.looping();
            }
            module.verbose('Restoring original attributes', module.cache);
          }
        },

        add: {
          failSafe() {
            const duration = module.get.duration();
            module.timer = setTimeout(module.complete, duration + 100);
            module.verbose('Adding fail safe timer', module.timer);
          }
        },

        remove: {
          animating() {
            $module.removeClass(className.animating);
          },
          animation() {
            $module.css({
              '-webkit-animation': '',
              '-moz-animation': '',
              '-ms-animation': '',
              '-o-animation': '',
              animation: ''
            });
          },
          animationEndCallback() {
            $module.off('.complete');
          },
          display() {
            $module.css('display', '');
          },
          direction() {
            $module
              .removeClass(className.inward)
              .removeClass(className.outward);
          },
          failSafe() {
            module.verbose('Removing fail safe timer', module.timer);
            if (module.timer) {
              clearTimeout(module.timer);
            }
          },
          hidden() {
            $module.removeClass(className.hidden);
          },
          visible() {
            $module.removeClass(className.visible);
          },
          looping() {
            module.debug('Transitions are no longer looping');
            $module.removeClass(className.looping);
            module.forceRepaint();
          },
          transition() {
            $module
              .removeClass(className.visible)
              .removeClass(className.hidden);
          }
        },
        get: {
          settings(animation, duration, onComplete) {
            // single settings object
            if (typeof animation === 'object') {
              return $.extend(true, {}, $.fn.transition.settings, animation);
            }
            // all arguments provided
            if (typeof onComplete === 'function') {
              return $.extend({}, $.fn.transition.settings, {
                animation,
                onComplete,
                duration
              });
            }
            // only duration provided
            if (typeof duration === 'string' || typeof duration === 'number') {
              return $.extend({}, $.fn.transition.settings, {
                animation,
                duration
              });
            }
            // duration is actually settings object
            if (typeof duration === 'object') {
              return $.extend({}, $.fn.transition.settings, duration, {
                animation
              });
            }
            // duration is actually callback
            if (typeof duration === 'function') {
              return $.extend({}, $.fn.transition.settings, {
                animation,
                onComplete: duration
              });
            }
            // only animation provided

            return $.extend({}, $.fn.transition.settings, {
              animation
            });

            return $.fn.transition.settings;
          },
          duration(duration) {
            duration = duration || settings.duration;
            return typeof settings.duration === 'string'
              ? duration.indexOf('ms') > -1
                ? parseFloat(duration)
                : parseFloat(duration) * 1000
              : duration;
          },
          displayType() {
            if (settings.displayType) {
              return settings.displayType;
            }
            if ($module.data(metadata.displayType) === undefined) {
              // create fake element to determine display state
              module.can.transition(true);
            }
            return $module.data(metadata.displayType);
          },
          style() {
            const style = $module.attr('style') || '';
            return style.replace(/display.*?;/, '');
          },
          transitionExists(animation) {
            return $.fn.transition.exists[animation];
          },
          animationName() {
            const element = document.createElement('div');
            const animations = {
              animation: 'animationName',
              OAnimation: 'oAnimationName',
              MozAnimation: 'mozAnimationName',
              WebkitAnimation: 'webkitAnimationName'
            };
            let animation;
            for (animation in animations) {
              if (element.style[animation] !== undefined) {
                return animations[animation];
              }
            }
            return false;
          },
          animationStartEvent() {
            const element = document.createElement('div');
            const animations = {
              animation: 'animationstart',
              OAnimation: 'oAnimationStart',
              MozAnimation: 'mozAnimationStart',
              WebkitAnimation: 'webkitAnimationStart'
            };
            let animation;
            for (animation in animations) {
              if (element.style[animation] !== undefined) {
                return animations[animation];
              }
            }
            return false;
          },
          animationEndEvent() {
            const element = document.createElement('div');
            const animations = {
              animation: 'animationend',
              OAnimation: 'oAnimationEnd',
              MozAnimation: 'mozAnimationEnd',
              WebkitAnimation: 'webkitAnimationEnd'
            };
            let animation;
            for (animation in animations) {
              if (element.style[animation] !== undefined) {
                return animations[animation];
              }
            }
            return false;
          }
        },

        can: {
          transition(forced) {
            const elementClass = $module.attr('class');
            const tagName = $module.prop('tagName');
            const { animation } = settings;
            const transitionExists = module.get.transitionExists(animation);
            let $clone;
            let currentAnimation;
            let inAnimation;
            let directionExists;
            let displayType;
            if (transitionExists === undefined || forced) {
              module.verbose('Determining whether animation exists');
              $clone = $(`<${tagName} />`)
                .addClass(elementClass)
                .insertAfter($module);
              currentAnimation = $clone
                .addClass(animation)
                .removeClass(className.inward)
                .removeClass(className.outward)
                .addClass(className.animating)
                .addClass(className.transition)
                .css(animationName);
              inAnimation = $clone
                .addClass(className.inward)
                .css(animationName);
              displayType = $clone
                .attr('class', elementClass)
                .removeAttr('style')
                .removeClass(className.hidden)
                .removeClass(className.visible)
                .show()
                .css('display');
              module.verbose('Determining final display state', displayType);
              $clone.remove();
              if (currentAnimation != inAnimation) {
                module.debug('Direction exists for animation', animation);
                directionExists = true;
              } else if (currentAnimation == 'none' || !currentAnimation) {
                module.debug('No animation defined in css', animation);
                return;
              } else {
                module.debug('Static animation found', animation, displayType);
                directionExists = false;
              }
              module.save.displayType(displayType);
              module.save.transitionExists(animation, directionExists);
            }
            return transitionExists !== undefined
              ? transitionExists
              : directionExists;
          },
          animate() {
            // can transition does not return a value if animation does not exist
            return module.can.transition() !== undefined;
          }
        },

        is: {
          animating() {
            return $module.hasClass(className.animating);
          },
          inward() {
            return $module.hasClass(className.inward);
          },
          outward() {
            return $module.hasClass(className.outward);
          },
          looping() {
            return $module.hasClass(className.looping);
          },
          occuring(animation) {
            animation = animation || settings.animation;
            animation = animation.replace(' ', '.');
            return $module.filter(animation).size() > 0;
          },
          visible() {
            return $module.is(':visible');
          },
          hidden() {
            return $module.css('visibility') === 'hidden';
          },
          supported() {
            return animationName !== false && animationEnd !== false;
          }
        },

        hide() {
          module.verbose('Hiding element');
          if (module.is.animating()) {
            module.reset();
          }
          module.remove.display();
          module.remove.visible();
          module.set.hidden();
          module.repaint();
        },

        show(display) {
          module.verbose('Showing element', display);
          module.remove.hidden();
          module.set.visible();
          module.repaint();
        },

        start() {
          module.verbose('Starting animation');
          $module.removeClass(className.disabled);
        },

        stop() {
          module.debug('Stopping animation');
          $module.addClass(className.disabled);
        },

        toggle() {
          module.debug('Toggling play status');
          $module.toggleClass(className.disabled);
        },

        setting(name, value) {
          module.debug('Changing setting', name, value);
          if ($.isPlainObject(name)) {
            $.extend(true, settings, name);
          } else if (value !== undefined) {
            settings[name] = value;
          } else {
            return settings[name];
          }
        },
        internal(name, value) {
          if ($.isPlainObject(name)) {
            $.extend(true, module, name);
          } else if (value !== undefined) {
            module[name] = value;
          } else {
            return module[name];
          }
        },
        debug() {
          if (settings.debug) {
            if (settings.performance) {
              module.performance.log(arguments);
            } else {
              module.debug = Function.prototype.bind.call(
                console.info,
                console,
                `${settings.name}:`
              );
              module.debug.apply(console, arguments);
            }
          }
        },
        verbose() {
          if (settings.verbose && settings.debug) {
            if (settings.performance) {
              module.performance.log(arguments);
            } else {
              module.verbose = Function.prototype.bind.call(
                console.info,
                console,
                `${settings.name}:`
              );
              module.verbose.apply(console, arguments);
            }
          }
        },
        error() {
          module.error = Function.prototype.bind.call(
            console.error,
            console,
            `${settings.name}:`
          );
          module.error.apply(console, arguments);
        },
        performance: {
          log(message) {
            let currentTime;
            let executionTime;
            let previousTime;
            if (settings.performance) {
              currentTime = new Date().getTime();
              previousTime = time || currentTime;
              executionTime = currentTime - previousTime;
              time = currentTime;
              performance.push({
                Name: message[0],
                Arguments: [].slice.call(message, 1) || '',
                Element: element,
                'Execution Time': executionTime
              });
            }
            clearTimeout(module.performance.timer);
            module.performance.timer = setTimeout(
              module.performance.display,
              600
            );
          },
          display() {
            let title = `${settings.name}:`;
            let totalTime = 0;
            time = false;
            clearTimeout(module.performance.timer);
            $.each(performance, function (index, data) {
              totalTime += data['Execution Time'];
            });
            title += ` ${totalTime}ms`;
            if (moduleSelector) {
              title += ` '${moduleSelector}'`;
            }
            if ($allModules.size() > 1) {
              title += `${' ' + '('}${$allModules.size()})`;
            }
            if (
              (console.group !== undefined || console.table !== undefined) &&
              performance.length > 0
            ) {
              console.groupCollapsed(title);
              if (console.table) {
                console.table(performance);
              } else {
                $.each(performance, function (index, data) {
                  console.log(`${data.Name}: ${data['Execution Time']}ms`);
                });
              }
              console.groupEnd();
            }
            performance = [];
          }
        },
        // modified for transition to return invoke success
        invoke(query, passedArguments, context) {
          let object = instance;
          let maxDepth;
          let found;
          let response;
          passedArguments = passedArguments || queryArguments;
          context = element || context;
          if (typeof query === 'string' && object !== undefined) {
            query = query.split(/[\. ]/);
            maxDepth = query.length - 1;
            $.each(query, function (depth, value) {
              const camelCaseValue =
                depth != maxDepth
                  ? value +
                    query[depth + 1].charAt(0).toUpperCase() +
                    query[depth + 1].slice(1)
                  : query;
              if (
                $.isPlainObject(object[camelCaseValue]) &&
                depth != maxDepth
              ) {
                object = object[camelCaseValue];
              } else if (object[camelCaseValue] !== undefined) {
                found = object[camelCaseValue];
                return false;
              } else if ($.isPlainObject(object[value]) && depth != maxDepth) {
                object = object[value];
              } else if (object[value] !== undefined) {
                found = object[value];
                return false;
              } else {
                return false;
              }
            });
          }
          if ($.isFunction(found)) {
            response = found.apply(context, passedArguments);
          } else if (found !== undefined) {
            response = found;
          }

          if ($.isArray(returnedValue)) {
            returnedValue.push(response);
          } else if (returnedValue !== undefined) {
            returnedValue = [returnedValue, response];
          } else if (response !== undefined) {
            returnedValue = response;
          }
          return found !== undefined ? found : false;
        }
      };
      module.initialize();
    });
    return returnedValue !== undefined ? returnedValue : this;
  };

  // Records if CSS transition is available
  $.fn.transition.exists = {};

  $.fn.transition.settings = {
    // module info
    name: 'Transition',

    // debug content outputted to console
    debug: false,

    // verbose debug output
    verbose: true,

    // performance data output
    performance: true,

    // event namespace
    namespace: 'transition',

    // animation complete event
    onStart() {},
    onComplete() {},
    onShow() {},
    onHide() {},

    // whether timeout should be used to ensure callback fires in cases animationend does not
    useFailSafe: false,

    // whether EXACT animation can occur twice in a row
    allowRepeats: false,

    // Override final display type on visible
    displayType: false,

    // animation duration
    animation: 'fade',
    duration: '500ms',

    // new animations will occur after previous ones
    queue: true,

    metadata: {
      displayType: 'display'
    },

    className: {
      animating: 'animating',
      disabled: 'disabled',
      hidden: 'hidden',
      inward: 'in',
      loading: 'loading',
      looping: 'looping',
      outward: 'out',
      transition: 'transition',
      visible: 'visible'
    },

    // possible errors
    error: {
      noAnimation: 'There is no css animation matching the one you specified.',
      repeated:
        'That animation is already occurring, cancelling repeated animation',
      method: 'The method you called is not defined',
      support: 'This browser does not support CSS animations'
    }
  };
})(jQuery, window, document);

/*
 * # Semantic - Form Validation
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Copyright 2014 Contributor
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */

(function ($, window, document, undefined) {
  $.fn.form = function (fields, parameters) {
    const $allModules = $(this);
    const settings = $.extend(true, {}, $.fn.form.settings, parameters);
    const validation = $.extend({}, $.fn.form.settings.defaults, fields);
    const { namespace } = settings;
    const { metadata } = settings;
    const { selector } = settings;
    const { className } = settings;
    const { error } = settings;
    const eventNamespace = `.${namespace}`;
    const moduleNamespace = `module-${namespace}`;
    const moduleSelector = $allModules.selector || '';
    let time = new Date().getTime();
    let performance = [];
    const query = arguments[0];
    const methodInvoked = typeof query === 'string';
    const queryArguments = [].slice.call(arguments, 1);
    let returnedValue;
    $allModules.each(function () {
      const $module = $(this);
      let $field = $(this).find(selector.field);
      const $group = $(this).find(selector.group);
      const $message = $(this).find(selector.message);
      const $prompt = $(this).find(selector.prompt);
      const $submit = $(this).find(selector.submit);
      let formErrors = [];
      const element = this;
      let instance = $module.data(moduleNamespace);
      let module;

      module = {
        initialize() {
          module.verbose(
            'Initializing form validation',
            $module,
            validation,
            settings
          );
          module.bindEvents();
          module.instantiate();
        },

        instantiate() {
          module.verbose('Storing instance of module', module);
          instance = module;
          $module.data(moduleNamespace, module);
        },

        destroy() {
          module.verbose('Destroying previous module', instance);
          module.removeEvents();
          $module.removeData(moduleNamespace);
        },

        refresh() {
          module.verbose('Refreshing selector cache');
          $field = $module.find(selector.field);
        },

        submit() {
          module.verbose('Submitting form', $module);
          $module.submit();
        },

        attachEvents(selector, action) {
          action = action || 'submit';
          $(selector).on('click', function (event) {
            module[action]();
            event.preventDefault();
          });
        },

        bindEvents() {
          if (settings.keyboardShortcuts) {
            $field.on(`keydown${eventNamespace}`, module.event.field.keydown);
          }
          $module.on(`submit${eventNamespace}`, module.validate.form);
          $field.on(`blur${eventNamespace}`, module.event.field.blur);
          // attach submit events
          module.attachEvents($submit, 'submit');

          $field.each(function () {
            const type = $(this).prop('type');
            const inputEvent = module.get.changeEvent(type);
            $(this).on(inputEvent + eventNamespace, module.event.field.change);
          });
        },

        removeEvents() {
          $module.off(eventNamespace);
          $field.off(eventNamespace);
          $submit.off(eventNamespace);
          $field.off(eventNamespace);
        },

        event: {
          field: {
            keydown(event) {
              const $field = $(this);
              const key = event.which;
              const keyCode = {
                enter: 13,
                escape: 27
              };
              if (key == keyCode.escape) {
                module.verbose('Escape key pressed blurring field');
                $field.blur();
              }
              if (
                !event.ctrlKey &&
                key == keyCode.enter &&
                $field.is(selector.input) &&
                $field.not(selector.checkbox).size() > 0
              ) {
                module.debug('Enter key pressed, submitting form');
                $submit.addClass(className.down);
                $field.one(`keyup${eventNamespace}`, module.event.field.keyup);
              }
            },
            keyup() {
              module.verbose('Doing keyboard shortcut form submit');
              $submit.removeClass(className.down);
              module.submit();
            },
            blur() {
              const $field = $(this);
              const $fieldGroup = $field.closest($group);
              if ($fieldGroup.hasClass(className.error)) {
                module.debug(
                  'Revalidating field',
                  $field,
                  module.get.validation($field)
                );
                module.validate.field(module.get.validation($field));
              } else if (settings.on == 'blur' || settings.on == 'change') {
                module.validate.field(module.get.validation($field));
              }
            },
            change() {
              const $field = $(this);
              const $fieldGroup = $field.closest($group);
              if (
                settings.on == 'change' ||
                ($fieldGroup.hasClass(className.error) && settings.revalidate)
              ) {
                clearTimeout(module.timer);
                module.timer = setTimeout(function () {
                  module.debug(
                    'Revalidating field',
                    $field,
                    module.get.validation($field)
                  );
                  module.validate.field(module.get.validation($field));
                }, settings.delay);
              }
            }
          }
        },

        get: {
          changeEvent(type) {
            if (type == 'checkbox' || type == 'radio' || type == 'hidden') {
              return 'change';
            }
            return document.createElement('input').oninput !== undefined
              ? 'input'
              : document.createElement('input').onpropertychange !== undefined
              ? 'propertychange'
              : 'keyup';
          },
          field(identifier) {
            module.verbose('Finding field with identifier', identifier);
            if ($field.filter(`#${identifier}`).size() > 0) {
              return $field.filter(`#${identifier}`);
            }
            if ($field.filter(`[name="${identifier}"]`).size() > 0) {
              return $field.filter(`[name="${identifier}"]`);
            }
            if (
              $field
                .filter(`[data-${metadata.validate}="${identifier}"]`)
                .size() > 0
            ) {
              return $field.filter(
                `[data-${metadata.validate}="${identifier}"]`
              );
            }
            return $('<input/>');
          },
          validation($field) {
            let rules;
            $.each(validation, function (fieldName, field) {
              if (module.get.field(field.identifier).get(0) == $field.get(0)) {
                rules = field;
              }
            });
            return rules || false;
          }
        },

        has: {
          field(identifier) {
            module.verbose(
              'Checking for existence of a field with identifier',
              identifier
            );
            if ($field.filter(`#${identifier}`).size() > 0) {
              return true;
            }
            if ($field.filter(`[name="${identifier}"]`).size() > 0) {
              return true;
            }
            if (
              $field
                .filter(`[data-${metadata.validate}="${identifier}"]`)
                .size() > 0
            ) {
              return true;
            }
            return false;
          }
        },

        add: {
          prompt(identifier, errors) {
            const $field = module.get.field(identifier);
            const $fieldGroup = $field.closest($group);
            let $prompt = $fieldGroup.find(selector.prompt);
            const promptExists = $prompt.size() !== 0;
            errors = typeof errors === 'string' ? [errors] : errors;
            module.verbose('Adding field error state', identifier);
            $fieldGroup.addClass(className.error);
            if (settings.inline) {
              if (!promptExists) {
                $prompt = settings.templates.prompt(errors);
                $prompt.appendTo($fieldGroup);
              }
              $prompt.html(errors[0]);
              if (!promptExists) {
                if (
                  settings.transition &&
                  $.fn.transition !== undefined &&
                  $module.transition('is supported')
                ) {
                  module.verbose(
                    'Displaying error with css transition',
                    settings.transition
                  );
                  $prompt.transition(
                    `${settings.transition} in`,
                    settings.duration
                  );
                } else {
                  module.verbose(
                    'Displaying error with fallback javascript animation'
                  );
                  $prompt.fadeIn(settings.duration);
                }
              } else {
                module.verbose(
                  'Inline errors are disabled, no inline error added',
                  identifier
                );
              }
            }
          },
          errors(errors) {
            module.debug('Adding form error messages', errors);
            $message.html(settings.templates.error(errors));
          }
        },

        remove: {
          prompt(field) {
            const $field = module.get.field(field.identifier);
            const $fieldGroup = $field.closest($group);
            const $prompt = $fieldGroup.find(selector.prompt);
            $fieldGroup.removeClass(className.error);
            if (settings.inline && $prompt.is(':visible')) {
              module.verbose('Removing prompt for field', field);
              if (
                settings.transition &&
                $.fn.transition !== undefined &&
                $module.transition('is supported')
              ) {
                $prompt.transition(
                  `${settings.transition} out`,
                  settings.duration,
                  function () {
                    $prompt.remove();
                  }
                );
              } else {
                $prompt.fadeOut(settings.duration, function () {
                  $prompt.remove();
                });
              }
            }
          }
        },

        set: {
          success() {
            $module.removeClass(className.error).addClass(className.success);
          },
          error() {
            $module.removeClass(className.success).addClass(className.error);
          }
        },

        validate: {
          form(event) {
            let allValid = true;
            let apiRequest;
            // reset errors
            formErrors = [];
            $.each(validation, function (fieldName, field) {
              if (!module.validate.field(field)) {
                allValid = false;
              }
            });
            if (allValid) {
              module.debug('Form has no validation errors, submitting');
              module.set.success();
              return $.proxy(settings.onSuccess, this)(event);
            }
            module.debug('Form has errors');
            module.set.error();
            if (!settings.inline) {
              module.add.errors(formErrors);
            }
            // prevent ajax submit
            if ($module.data('moduleApi') !== undefined) {
              event.stopImmediatePropagation();
            }
            return $.proxy(settings.onFailure, this)(formErrors);
          },

          // takes a validation object and returns whether field passes validation
          field(field) {
            const $field = module.get.field(field.identifier);
            let fieldValid = true;
            const fieldErrors = [];
            if (field.optional && $.trim($field.val()) === '') {
              module.debug(
                'Field is optional and empty. Skipping',
                field.identifier
              );
              fieldValid = true;
            } else if (field.rules !== undefined) {
              $.each(field.rules, function (index, rule) {
                if (
                  module.has.field(field.identifier) &&
                  !module.validate.rule(field, rule)
                ) {
                  module.debug('Field is invalid', field.identifier, rule.type);
                  fieldErrors.push(rule.prompt);
                  fieldValid = false;
                }
              });
            }
            if (fieldValid) {
              module.remove.prompt(field, fieldErrors);
              $.proxy(settings.onValid, $field)();
            } else {
              formErrors = formErrors.concat(fieldErrors);
              module.add.prompt(field.identifier, fieldErrors);
              $.proxy(settings.onInvalid, $field)(fieldErrors);
              return false;
            }
            return true;
          },

          // takes validation rule and returns whether field passes rule
          rule(field, validation) {
            const $field = module.get.field(field.identifier);
            const { type } = validation;
            const value = $.trim(`${$field.val()}`);
            const bracketRegExp = /\[(.*)\]/i;
            const bracket = bracketRegExp.exec(type);
            let isValid = true;
            let ancillary;
            let functionType;
            // if bracket notation is used, pass in extra parameters
            if (bracket !== undefined && bracket !== null) {
              ancillary = `${bracket[1]}`;
              functionType = type.replace(bracket[0], '');
              isValid = $.proxy(settings.rules[functionType], $module)(
                value,
                ancillary
              );
            }
            // normal notation
            else {
              isValid = $.proxy(settings.rules[type], $field)(value);
            }
            return isValid;
          }
        },

        setting(name, value) {
          if ($.isPlainObject(name)) {
            $.extend(true, settings, name);
          } else if (value !== undefined) {
            settings[name] = value;
          } else {
            return settings[name];
          }
        },
        internal(name, value) {
          if ($.isPlainObject(name)) {
            $.extend(true, module, name);
          } else if (value !== undefined) {
            module[name] = value;
          } else {
            return module[name];
          }
        },
        debug() {
          if (settings.debug) {
            if (settings.performance) {
              module.performance.log(arguments);
            } else {
              module.debug = Function.prototype.bind.call(
                console.info,
                console,
                `${settings.name}:`
              );
              module.debug.apply(console, arguments);
            }
          }
        },
        verbose() {
          if (settings.verbose && settings.debug) {
            if (settings.performance) {
              module.performance.log(arguments);
            } else {
              module.verbose = Function.prototype.bind.call(
                console.info,
                console,
                `${settings.name}:`
              );
              module.verbose.apply(console, arguments);
            }
          }
        },
        error() {
          module.error = Function.prototype.bind.call(
            console.error,
            console,
            `${settings.name}:`
          );
          module.error.apply(console, arguments);
        },
        performance: {
          log(message) {
            let currentTime;
            let executionTime;
            let previousTime;
            if (settings.performance) {
              currentTime = new Date().getTime();
              previousTime = time || currentTime;
              executionTime = currentTime - previousTime;
              time = currentTime;
              performance.push({
                Name: message[0],
                Arguments: [].slice.call(message, 1) || '',
                Element: element,
                'Execution Time': executionTime
              });
            }
            clearTimeout(module.performance.timer);
            module.performance.timer = setTimeout(
              module.performance.display,
              100
            );
          },
          display() {
            let title = `${settings.name}:`;
            let totalTime = 0;
            time = false;
            clearTimeout(module.performance.timer);
            $.each(performance, function (index, data) {
              totalTime += data['Execution Time'];
            });
            title += ` ${totalTime}ms`;
            if (moduleSelector) {
              title += ` '${moduleSelector}'`;
            }
            if ($allModules.size() > 1) {
              title += `${' ' + '('}${$allModules.size()})`;
            }
            if (
              (console.group !== undefined || console.table !== undefined) &&
              performance.length > 0
            ) {
              console.groupCollapsed(title);
              if (console.table) {
                console.table(performance);
              } else {
                $.each(performance, function (index, data) {
                  console.log(`${data.Name}: ${data['Execution Time']}ms`);
                });
              }
              console.groupEnd();
            }
            performance = [];
          }
        },
        invoke(query, passedArguments, context) {
          let object = instance;
          let maxDepth;
          let found;
          let response;
          passedArguments = passedArguments || queryArguments;
          context = element || context;
          if (typeof query === 'string' && object !== undefined) {
            query = query.split(/[\. ]/);
            maxDepth = query.length - 1;
            $.each(query, function (depth, value) {
              const camelCaseValue =
                depth != maxDepth
                  ? value +
                    query[depth + 1].charAt(0).toUpperCase() +
                    query[depth + 1].slice(1)
                  : query;
              if (
                $.isPlainObject(object[camelCaseValue]) &&
                depth != maxDepth
              ) {
                object = object[camelCaseValue];
              } else if (object[camelCaseValue] !== undefined) {
                found = object[camelCaseValue];
                return false;
              } else if ($.isPlainObject(object[value]) && depth != maxDepth) {
                object = object[value];
              } else if (object[value] !== undefined) {
                found = object[value];
                return false;
              } else {
                return false;
              }
            });
          }
          if ($.isFunction(found)) {
            response = found.apply(context, passedArguments);
          } else if (found !== undefined) {
            response = found;
          }
          if ($.isArray(returnedValue)) {
            returnedValue.push(response);
          } else if (returnedValue !== undefined) {
            returnedValue = [returnedValue, response];
          } else if (response !== undefined) {
            returnedValue = response;
          }
          return found;
        }
      };
      if (methodInvoked) {
        if (instance === undefined) {
          module.initialize();
        }
        module.invoke(query);
      } else {
        if (instance !== undefined) {
          module.destroy();
        }
        module.initialize();
      }
    });

    return returnedValue !== undefined ? returnedValue : this;
  };

  $.fn.form.settings = {
    name: 'Form',
    namespace: 'form',

    debug: false,
    verbose: true,
    performance: true,

    keyboardShortcuts: true,
    on: 'submit',
    inline: false,

    delay: 200,
    revalidate: true,

    transition: 'scale',
    duration: 200,

    onValid() {},
    onInvalid() {},
    onSuccess() {
      return true;
    },
    onFailure() {
      return false;
    },

    metadata: {
      validate: 'validate'
    },

    selector: {
      message: '.error.message',
      field: 'input, textarea, select',
      group: '.field',
      checkbox: 'input[type="checkbox"], input[type="radio"]',
      input: 'input',
      prompt: '.prompt',
      submit: '.submit'
    },

    className: {
      error: 'error',
      success: 'success',
      down: 'down',
      label: 'ui prompt label'
    },

    error: {
      method: 'The method you called is not defined.'
    },

    templates: {
      error(errors) {
        let html = '<ul class="list">';
        $.each(errors, function (index, value) {
          html += `<li>${value}</li>`;
        });
        html += '</ul>';
        return $(html);
      },
      prompt(errors) {
        return $('<div/>')
          .addClass('ui red pointing prompt label')
          .html(errors[0]);
      }
    },

    rules: {
      // checkbox checked
      checked() {
        return $(this).filter(':checked').size() > 0;
      },

      // value contains (text)
      contains(value, text) {
        text = text.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
        return value.search(text) !== -1;
      },

      // is most likely an email
      email(value) {
        const emailRegExp = new RegExp(
          "[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?",
          'i'
        );
        return emailRegExp.test(value);
      },

      // is not empty or blank string
      empty(value) {
        return !(value === undefined || value === '');
      },

      // is valid integer
      integer(value, range) {
        const intRegExp = /^\-?\d+$/;
        let min;
        let max;
        let parts;
        if (range === undefined || range === '' || range === '..') {
          // do nothing
        } else if (range.indexOf('..') == -1) {
          if (intRegExp.test(range)) {
            min = max = range - 0;
          }
        } else {
          parts = range.split('..', 2);
          if (intRegExp.test(parts[0])) {
            min = parts[0] - 0;
          }
          if (intRegExp.test(parts[1])) {
            max = parts[1] - 0;
          }
        }
        return (
          intRegExp.test(value) &&
          (min === undefined || value >= min) &&
          (max === undefined || value <= max)
        );
      },

      // is exactly value
      is(value, text) {
        return value == text;
      },

      // is at least string length
      length(value, requiredLength) {
        return value !== undefined ? value.length >= requiredLength : false;
      },

      // matches another field
      match(value, fieldIdentifier) {
        // use either id or name of field
        const $form = $(this);
        let matchingValue;
        if ($form.find(`#${fieldIdentifier}`).size() > 0) {
          matchingValue = $form.find(`#${fieldIdentifier}`).val();
        } else if ($form.find(`[name="${fieldIdentifier}"]`).size() > 0) {
          matchingValue = $form.find(`[name="${fieldIdentifier}"]`).val();
        } else if (
          $form.find(`[data-validate="${fieldIdentifier}"]`).size() > 0
        ) {
          matchingValue = $form
            .find(`[data-validate="${fieldIdentifier}"]`)
            .val();
        }
        return matchingValue !== undefined
          ? value.toString() == matchingValue.toString()
          : false;
      },

      // string length is less than max length
      maxLength(value, maxLength) {
        return value !== undefined ? value.length <= maxLength : false;
      },

      // value is not exactly notValue
      not(value, notValue) {
        return value != notValue;
      },

      // value is most likely url
      url(value) {
        const urlRegExp = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
        return urlRegExp.test(value);
      }
    }
  };
})(jQuery, window, document);

/*
 * # Semantic - Dropdown
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Copyright 2014 Contributor
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */

(function ($, window, document, undefined) {
  $.fn.dropdown = function (parameters) {
    const $allModules = $(this);
    const $document = $(document);
    const moduleSelector = $allModules.selector || '';
    const hasTouch = 'ontouchstart' in document.documentElement;
    let time = new Date().getTime();
    let performance = [];
    const query = arguments[0];
    const methodInvoked = typeof query === 'string';
    const queryArguments = [].slice.call(arguments, 1);
    let returnedValue;

    $allModules.each(function () {
      const settings = $.isPlainObject(parameters)
        ? $.extend(true, {}, $.fn.dropdown.settings, parameters)
        : $.extend({}, $.fn.dropdown.settings);
      const { className } = settings;
      const { metadata } = settings;
      const { namespace } = settings;
      const { selector } = settings;
      const { error } = settings;
      const eventNamespace = `.${namespace}`;
      const moduleNamespace = `module-${namespace}`;
      let $module = $(this);
      let $text = $module.find(selector.text);
      let $search = $module.find(selector.search);
      let $input = $module.find(selector.input);
      const $combo =
        $module.prev().find(selector.text).size() > 0
          ? $module.prev().find(selector.text)
          : $module.prev();
      let $menu = $module.children(selector.menu);
      let $item = $menu.find(selector.item);
      let activated = false;
      let itemActivated = false;
      const element = this;
      let instance = $module.data(moduleNamespace);
      let observer;
      let module;

      module = {
        initialize() {
          module.debug('Initializing dropdown', settings);
          module.setup.layout();
          module.save.defaults();
          module.set.selected();

          if (hasTouch) {
            module.bind.touchEvents();
          }
          module.bind.mouseEvents();
          module.bind.keyboardEvents();

          module.observeChanges();
          module.instantiate();
        },

        instantiate() {
          module.verbose('Storing instance of dropdown', module);
          instance = module;
          $module.data(moduleNamespace, module);
        },

        destroy() {
          module.verbose('Destroying previous dropdown for', $module);
          module.remove.tabbable();
          $module.off(eventNamespace).removeData(moduleNamespace);
        },

        observeChanges() {
          if ('MutationObserver' in window) {
            observer = new MutationObserver(function (mutations) {
              module.debug('DOM tree modified, updating selector cache');
              module.refresh();
            });
            observer.observe(element, {
              childList: true,
              subtree: true
            });
            module.debug('Setting up mutation observer', observer);
          }
        },

        setup: {
          layout() {
            if ($module.is('select')) {
              module.setup.select();
            }
            if (module.is.search() && !module.is.searchable()) {
              $search = $('<input />')
                .addClass(className.search)
                .insertBefore($text);
            }
            if (settings.allowTab) {
              module.set.tabbable();
            }
          },
          select() {
            const selectValues = module.get.selectValues();
            module.debug('Dropdown initialized on a select', selectValues);
            // see if select exists inside a dropdown
            $input = $module;
            if ($input.parents(selector.dropdown).size() > 0) {
              module.debug('Creating dropdown menu only from template');
              $module = $input.closest(selector.dropdown);
              if ($module.find(`.${className.dropdown}`).size() === 0) {
                $('<div />')
                  .addClass(className.menu)
                  .html(settings.templates.menu(selectValues))
                  .appendTo($module);
              }
            } else {
              module.debug('Creating entire dropdown from template');
              $module = $('<div />')
                .attr('class', $input.attr('class'))
                .addClass(className.selection)
                .addClass(className.dropdown)
                .html(settings.templates.dropdown(selectValues))
                .insertBefore($input);
              $input.removeAttr('class').prependTo($module);
            }
            module.refresh();
          }
        },

        refresh() {
          $text = $module.find(selector.text);
          $search = $module.find(selector.search);
          $input = $module.find(selector.input);
          $menu = $module.children(selector.menu);
          $item = $menu.find(selector.item);
        },

        toggle() {
          module.verbose('Toggling menu visibility');
          if (!module.is.active()) {
            module.show();
          } else {
            module.hide();
          }
        },

        show() {
          module.debug('Checking if dropdown can show');
          if (!module.is.active()) {
            module.animate.show(function () {
              if (module.can.click()) {
                module.bind.intent();
              }
              module.set.visible();
            });
            $.proxy(settings.onShow, element)();
          }
        },

        hide() {
          if (module.is.active()) {
            module.debug('Hiding dropdown');
            module.animate.hide(function () {
              module.remove.visible();
            });
            $.proxy(settings.onHide, element)();
          }
        },

        hideOthers() {
          module.verbose('Finding other dropdowns to hide');
          $allModules
            .not($module)
            .has(`${selector.menu}:visible:not(.${className.animating})`)
            .dropdown('hide');
        },

        hideSubMenus() {
          const $subMenus = $menu.find(selector.menu);
          $subMenus.transition('hide');
        },

        bind: {
          keyboardEvents() {
            module.debug('Binding keyboard events');
            $module.on(`keydown${eventNamespace}`, module.event.keydown);
            if (module.is.searchable()) {
              $module.on(
                module.get.inputEvent(),
                selector.search,
                module.event.input
              );
            }
          },
          touchEvents() {
            module.debug(
              'Touch device detected binding additional touch events'
            );
            if (module.is.searchSelection()) {
              // do nothing special yet
            } else {
              $module.on(
                `touchstart${eventNamespace}`,
                module.event.test.toggle
              );
            }
            $menu.on(
              `touchstart${eventNamespace}`,
              selector.item,
              module.event.item.mouseenter
            );
          },
          mouseEvents() {
            module.verbose('Mouse detected binding mouse events');
            if (module.is.searchSelection()) {
              $module
                .on(
                  `mousedown${eventNamespace}`,
                  selector.menu,
                  module.event.menu.activate
                )
                .on(
                  `mouseup${eventNamespace}`,
                  selector.menu,
                  module.event.menu.deactivate
                )
                .on(
                  `focus${eventNamespace}`,
                  selector.search,
                  module.event.searchFocus
                )
                .on(`click${eventNamespace}`, selector.search, module.show)
                .on(
                  `blur${eventNamespace}`,
                  selector.search,
                  module.event.searchBlur
                );
            } else {
              if (settings.on == 'click') {
                $module.on(`click${eventNamespace}`, module.event.test.toggle);
              } else if (settings.on == 'hover') {
                $module
                  .on(`mouseenter${eventNamespace}`, module.delay.show)
                  .on(`mouseleave${eventNamespace}`, module.delay.hide);
              } else {
                $module.on(settings.on + eventNamespace, module.toggle);
              }
              $module
                .on(`mousedown${eventNamespace}`, module.event.mousedown)
                .on(`mouseup${eventNamespace}`, module.event.mouseup)
                .on(`focus${eventNamespace}`, module.event.focus)
                .on(`blur${eventNamespace}`, module.event.blur);
            }
            $menu
              .on(
                `mouseenter${eventNamespace}`,
                selector.item,
                module.event.item.mouseenter
              )
              .on(
                `mouseleave${eventNamespace}`,
                selector.item,
                module.event.item.mouseleave
              )
              .on(
                `click${eventNamespace}`,
                selector.item,
                module.event.item.click
              );
          },
          intent() {
            module.verbose('Binding hide intent event to document');
            if (hasTouch) {
              $document
                .on(`touchstart${eventNamespace}`, module.event.test.touch)
                .on(`touchmove${eventNamespace}`, module.event.test.touch);
            }
            $document.on(`click${eventNamespace}`, module.event.test.hide);
          }
        },

        unbind: {
          intent() {
            module.verbose('Removing hide intent event from document');
            if (hasTouch) {
              $document
                .off(`touchstart${eventNamespace}`)
                .off(`touchmove${eventNamespace}`);
            }
            $document.off(`click${eventNamespace}`);
          }
        },

        filter(searchTerm) {
          let $results = $();
          const exactRegExp = new RegExp(`(?:s|^)${searchTerm}`, 'i');
          const fullTextRegExp = new RegExp(searchTerm, 'i');
          let allItemsFiltered;
          let $filteredItems;
          $item.each(function () {
            const $choice = $(this);
            const text =
              $choice.data(metadata.text) !== undefined
                ? $choice.data(metadata.text)
                : settings.preserveHTML
                ? $choice.html()
                : $choice.text();
            const value =
              $choice.data(metadata.value) !== undefined
                ? $choice.data(metadata.value)
                : typeof text === 'string'
                ? text.toLowerCase()
                : text;
            if (exactRegExp.test(text) || exactRegExp.test(value)) {
              $results = $results.add($choice);
            } else if (settings.fullTextSearch) {
              if (fullTextRegExp.test(text) || fullTextRegExp.test(value)) {
                $results = $results.add($choice);
              }
            }
          });
          $filteredItems = $item.not($results);
          allItemsFiltered = $filteredItems.size() == $item.size();

          module.remove.filteredItem();
          module.remove.selectedItem();
          $filteredItems.addClass(className.filtered);
          $item
            .not(`.${className.filtered}`)
            .eq(0)
            .addClass(className.selected);
          if (allItemsFiltered) {
            module.hide();
          }
        },

        focusSearch() {
          if (module.is.search()) {
            $search.focus();
          }
        },

        event: {
          // prevents focus callback from occuring on mousedown
          mousedown() {
            activated = true;
          },
          mouseup() {
            activated = false;
          },
          focus() {
            if (!activated && module.is.hidden()) {
              module.show();
            }
          },
          blur(event) {
            if (!activated) {
              module.hide();
            }
          },
          searchFocus() {
            activated = true;
            module.show();
          },
          searchBlur(event) {
            if (!itemActivated) {
              module.hide();
            }
          },
          input(event) {
            const query = $search.val();
            if (module.is.searchSelection()) {
              if (module.can.show()) {
                module.show();
              }
              module.set.filtered();
            }
            module.filter(query);
          },
          keydown(event) {
            let $selectedItem = $item
              .not(className.filtered)
              .filter(`.${className.selected}`)
              .eq(0);
            const $visibleItems = $item.not(`.${className.filtered}`);
            const pressedKey = event.which;
            const keys = {
              enter: 13,
              escape: 27,
              upArrow: 38,
              downArrow: 40
            };
            const selectedClass = className.selected;
            const currentIndex = $visibleItems.index($selectedItem);
            let hasSelectedItem = $selectedItem.size() > 0;
            let $nextItem;
            let newIndex;
            // default to activated choice if no selection present
            if (!hasSelectedItem) {
              $selectedItem = $item.filter(`.${className.active}`).eq(0);
              hasSelectedItem = $selectedItem.size() > 0;
            }
            // close shortcuts
            if (pressedKey == keys.escape) {
              module.verbose('Escape key pressed, closing dropdown');
              module.hide();
            }
            // result shortcuts
            if (module.is.visible()) {
              if (pressedKey == keys.enter && hasSelectedItem) {
                module.verbose('Enter key pressed, choosing selected item');
                $.proxy(module.event.item.click, $selectedItem)(event);
                event.preventDefault();
                return false;
              }
              if (pressedKey == keys.upArrow) {
                if (!hasSelectedItem) {
                  $nextItem = $visibleItems.eq(0);
                } else {
                  $nextItem = $selectedItem
                    .prevAll(`${selector.item}:not(.${className.filtered})`)
                    .eq(0);
                }
                if (currentIndex !== 0) {
                  module.verbose('Up key pressed, changing active item');
                  $item.removeClass(selectedClass);
                  $nextItem.addClass(selectedClass);
                  module.set.scrollPosition($nextItem);
                }
                event.preventDefault();
              } else if (pressedKey == keys.downArrow) {
                if (!hasSelectedItem) {
                  $nextItem = $visibleItems.eq(0);
                } else {
                  $nextItem = $selectedItem
                    .nextAll(`${selector.item}:not(.${className.filtered})`)
                    .eq(0);
                }
                if (currentIndex + 1 < $visibleItems.size()) {
                  module.verbose('Down key pressed, changing active item');
                  $item.removeClass(selectedClass);
                  $nextItem.addClass(selectedClass);
                  module.set.scrollPosition($nextItem);
                }
                event.preventDefault();
              }
            } else if (pressedKey == keys.enter) {
              module.show();
            }
          },
          test: {
            toggle(event) {
              if (module.determine.eventInMenu(event, module.toggle)) {
                event.preventDefault();
              }
            },
            touch(event) {
              module.determine.eventInMenu(event, function () {
                if (event.type == 'touchstart') {
                  module.timer = setTimeout(module.hide, settings.delay.touch);
                } else if (event.type == 'touchmove') {
                  clearTimeout(module.timer);
                }
              });
              event.stopPropagation();
            },
            hide(event) {
              module.determine.eventInModule(event, module.hide);
            }
          },

          menu: {
            activate() {
              itemActivated = true;
            },
            deactivate() {
              itemActivated = false;
            }
          },
          item: {
            mouseenter(event) {
              const $currentMenu = $(this).children(selector.menu);
              const $otherMenus = $(this)
                .siblings(selector.item)
                .children(selector.menu);
              if ($currentMenu.size() > 0) {
                clearTimeout(module.itemTimer);
                module.itemTimer = setTimeout(function () {
                  $.each($otherMenus, function () {
                    module.animate.hide(false, $(this));
                  });
                  module.verbose('Showing sub-menu', $currentMenu);
                  module.animate.show(false, $currentMenu);
                }, settings.delay.show);
                event.preventDefault();
              }
            },

            mouseleave(event) {
              const $currentMenu = $(this).children(selector.menu);
              if ($currentMenu.size() > 0) {
                clearTimeout(module.itemTimer);
                module.itemTimer = setTimeout(function () {
                  module.verbose('Hiding sub-menu', $currentMenu);
                  module.animate.hide(false, $currentMenu);
                }, settings.delay.hide);
              }
            },

            click(event) {
              const $choice = $(this);
              const text =
                $choice.data(metadata.text) !== undefined
                  ? $choice.data(metadata.text)
                  : settings.preserveHTML
                  ? $choice.html()
                  : $choice.text();
              const value =
                $choice.data(metadata.value) !== undefined
                  ? $choice.data(metadata.value)
                  : typeof text === 'string'
                  ? text.toLowerCase()
                  : text;
              const callback = function () {
                module.remove.searchTerm();
                module.remove.filteredItem();
                module.determine.selectAction(text, value);
              };
              const openingSubMenu = $choice.find(selector.menu).size() > 0;
              if (!openingSubMenu) {
                callback();
              }
            }
          },

          resetStyle() {
            $(this).removeAttr('style');
          }
        },

        determine: {
          selectAction(text, value) {
            module.verbose('Determining action', settings.action);
            if ($.isFunction(module.action[settings.action])) {
              module.verbose(
                'Triggering preset action',
                settings.action,
                text,
                value
              );
              module.action[settings.action](text, value);
            } else if ($.isFunction(settings.action)) {
              module.verbose(
                'Triggering user action',
                settings.action,
                text,
                value
              );
              settings.action(text, value);
            } else {
              module.error(error.action, settings.action);
            }
          },
          eventInModule(event, callback) {
            callback = callback || function () {};
            if ($(event.target).closest($module).size() === 0) {
              module.verbose('Triggering event', callback);
              callback();
              return true;
            }
            module.verbose('Event occurred in dropdown, canceling callback');
            return false;
          },
          eventInMenu(event, callback) {
            callback = callback || function () {};
            if ($(event.target).closest($menu).size() === 0) {
              module.verbose('Triggering event', callback);
              callback();
              return true;
            }
            module.verbose(
              'Event occurred in dropdown menu, canceling callback'
            );
            return false;
          }
        },

        action: {
          nothing() {},

          hide() {
            module.hide();
          },

          select(text, value) {
            value = value !== undefined ? value : text;
            module.set.selected(value);
            module.set.value(value);
            module.hide();
          },

          activate(text, value) {
            value = value !== undefined ? value : text;
            module.set.selected(value);
            module.set.value(value);
            module.hide();
          },

          combo(text, value) {
            value = value !== undefined ? value : text;
            module.set.selected(value);
            module.set.value(value);
            module.hide();
          }
        },

        get: {
          text() {
            return $text.text();
          },
          value() {
            return $input.size() > 0
              ? $input.val()
              : $module.data(metadata.value);
          },
          inputEvent() {
            const input = $search[0];
            if (input) {
              return input.oninput !== undefined
                ? 'input'
                : input.onpropertychange !== undefined
                ? 'propertychange'
                : 'keyup';
            }
            return false;
          },
          selectValues() {
            const select = {
              values: {}
            };
            $module.find('option').each(function () {
              const name = $(this).html();
              const value =
                $(this).attr('value') !== undefined
                  ? $(this).attr('value')
                  : name;
              if (value === '') {
                select.placeholder = name;
              } else {
                select.values[value] = name;
              }
            });
            module.debug('Retrieved values from select', select);
            return select;
          },
          item(value, strict) {
            let $selectedItem = false;
            value =
              value !== undefined
                ? value
                : module.get.value() !== undefined
                ? module.get.value()
                : module.get.text();
            strict = value === '' || value === 0 ? true : strict || false;
            if (value !== undefined) {
              $item.each(function () {
                const $choice = $(this);
                const optionText =
                  $choice.data(metadata.text) !== undefined
                    ? $choice.data(metadata.text)
                    : settings.preserveHTML
                    ? $choice.html()
                    : $choice.text();
                const optionValue =
                  $choice.data(metadata.value) !== undefined
                    ? $choice.data(metadata.value)
                    : typeof optionText === 'string'
                    ? optionText.toLowerCase()
                    : optionText;
                if (strict) {
                  module.verbose(
                    'Ambiguous dropdown value using strict type check',
                    $choice,
                    value
                  );
                  if (optionValue === value) {
                    $selectedItem = $(this);
                  } else if (!$selectedItem && optionText === value) {
                    $selectedItem = $(this);
                  }
                } else if (optionValue == value) {
                  module.verbose(
                    'Found select item by value',
                    optionValue,
                    value
                  );
                  $selectedItem = $(this);
                } else if (!$selectedItem && optionText == value) {
                  module.verbose(
                    'Found select item by text',
                    optionText,
                    value
                  );
                  $selectedItem = $(this);
                }
              });
            } else {
              value = module.get.text();
            }
            return $selectedItem || false;
          }
        },

        restore: {
          defaults() {
            module.restore.defaultText();
            module.restore.defaultValue();
          },
          defaultText() {
            const defaultText = $module.data(metadata.defaultText);
            module.debug('Restoring default text', defaultText);
            module.set.text(defaultText);
          },
          defaultValue() {
            const defaultValue = $module.data(metadata.defaultValue);
            if (defaultValue !== undefined) {
              module.debug('Restoring default value', defaultValue);
              module.set.selected(defaultValue);
              module.set.value(defaultValue);
            }
          }
        },

        save: {
          defaults() {
            module.save.defaultText();
            module.save.defaultValue();
          },
          defaultValue() {
            $module.data(metadata.defaultValue, module.get.value());
          },
          defaultText() {
            $module.data(metadata.defaultText, $text.text());
          }
        },

        set: {
          filtered() {
            $text.addClass(className.filtered);
          },
          tabbable() {
            if (module.is.searchable()) {
              module.debug('Searchable dropdown initialized');
              $search.val('').attr('tabindex', 0);
              $menu.attr('tabindex', '-1');
            } else {
              module.debug('Simple selection dropdown initialized');
              if (!$module.attr('tabindex')) {
                $module.attr('tabindex', 0);
                $menu.attr('tabindex', '-1');
              }
            }
          },
          scrollPosition($item) {
            var $item = $item || module.get.item();
            const hasActive = $item && $item.size() > 0;
            const edgeTolerance = 5;
            let offset;
            let itemHeight;
            let itemOffset;
            let menuOffset;
            let menuScroll;
            let menuHeight;
            let abovePage;
            let belowPage;
            if ($item && hasActive) {
              menuHeight = $menu.height();
              itemHeight = $item.height();
              menuScroll = $menu.scrollTop();
              menuOffset = $menu.offset().top;
              itemOffset = $item.offset().top;
              offset = menuScroll - menuOffset + itemOffset;
              belowPage = menuScroll + menuHeight < offset + edgeTolerance;
              abovePage = offset - edgeTolerance < menuScroll;
              if (abovePage || belowPage) {
                module.debug('Scrolling to active item');
                $menu.scrollTop(offset);
              }
            }
          },
          text(text) {
            if (settings.action == 'combo') {
              module.debug('Changing combo button text', text, $combo);
              if (settings.preserveHTML) {
                $combo.html(text);
              } else {
                $combo.text(text);
              }
            } else if (settings.action !== 'select') {
              module.debug('Changing text', text, $text);
              $text
                .removeClass(className.filtered)
                .removeClass(className.placeholder);
              if (settings.preserveHTML) {
                $text.html(text);
              } else {
                $text.text(text);
              }
            }
          },
          value(value) {
            module.debug(
              'Adding selected value to hidden input',
              value,
              $input
            );
            if ($input.size() > 0) {
              $input.val(value).trigger('change');
            } else {
              $module.data(metadata.value, value);
            }
          },
          active() {
            $module.addClass(className.active);
          },
          visible() {
            $module.addClass(className.visible);
          },
          selected(value) {
            const $selectedItem = module.get.item(value);
            let selectedText;
            if ($selectedItem) {
              module.debug('Setting selected menu item to', $selectedItem);
              selectedText =
                $selectedItem.data(metadata.text) !== undefined
                  ? $selectedItem.data(metadata.text)
                  : settings.preserveHTML
                  ? $selectedItem.html()
                  : $selectedItem.text();
              module.remove.activeItem();
              module.remove.selectedItem();
              $selectedItem
                .addClass(className.active)
                .addClass(className.selected);
              module.set.text(selectedText);
              $.proxy(settings.onChange, element)(
                value,
                selectedText,
                $selectedItem
              );
            }
          }
        },

        remove: {
          active() {
            $module.removeClass(className.active);
          },
          visible() {
            $module.removeClass(className.visible);
          },
          activeItem() {
            $item.removeClass(className.active);
          },
          filteredItem() {
            $item.removeClass(className.filtered);
          },
          searchTerm() {
            $search.val('');
          },
          selectedItem() {
            $item.removeClass(className.selected);
          },
          tabbable() {
            if (module.is.searchable()) {
              module.debug('Searchable dropdown initialized');
              $search.attr('tabindex', '-1');
              $menu.attr('tabindex', '-1');
            } else {
              module.debug('Simple selection dropdown initialized');
              $module.attr('tabindex', '-1');
              $menu.attr('tabindex', '-1');
            }
          }
        },

        is: {
          search() {
            return $module.hasClass(className.search);
          },
          searchable() {
            return $search.size() > 0;
          },
          searchSelection() {
            return module.is.searchable() && $search.parent().is($module);
          },
          selection() {
            return $module.hasClass(className.selection);
          },
          animating($subMenu) {
            return $subMenu
              ? $subMenu.is(':animated') ||
                  ($subMenu.transition && $subMenu.transition('is animating'))
              : $menu.is(':animated') ||
                  ($menu.transition && $menu.transition('is animating'));
          },
          active() {
            return $module.hasClass(className.active);
          },
          visible($subMenu) {
            return $subMenu ? $subMenu.is(':visible') : $menu.is(':visible');
          },
          hidden($subMenu) {
            return $subMenu ? $subMenu.is(':hidden') : $menu.is(':hidden');
          }
        },

        can: {
          click() {
            return hasTouch || settings.on == 'click';
          },
          show() {
            return !$module.hasClass(className.disabled);
          }
        },

        animate: {
          show(callback, $subMenu) {
            const $currentMenu = $subMenu || $menu;
            const start = $subMenu
              ? function () {}
              : function () {
                  module.hideSubMenus();
                  module.hideOthers();
                  module.set.active();
                  module.set.scrollPosition();
                };
            callback = callback || function () {};
            module.verbose('Doing menu show animation', $currentMenu);
            if (
              module.is.hidden($currentMenu) ||
              module.is.animating($currentMenu)
            ) {
              if (settings.transition == 'none') {
                $.proxy(callback, element)();
              } else if (
                $.fn.transition !== undefined &&
                $module.transition('is supported')
              ) {
                $currentMenu.transition({
                  animation: `${settings.transition} in`,
                  debug: settings.debug,
                  verbose: settings.verbose,
                  duration: settings.duration,
                  queue: true,
                  onStart: start,
                  onComplete() {
                    $.proxy(callback, element)();
                  }
                });
              } else if (settings.transition == 'slide down') {
                start();
                $currentMenu
                  .hide()
                  .clearQueue()
                  .children()
                  .clearQueue()
                  .css('opacity', 0)
                  .delay(50)
                  .animate(
                    {
                      opacity: 1
                    },
                    settings.duration,
                    'easeOutQuad',
                    module.event.resetStyle
                  )
                  .end()
                  .slideDown(100, 'easeOutQuad', function () {
                    $.proxy(module.event.resetStyle, this)();
                    $.proxy(callback, element)();
                  });
              } else if (settings.transition == 'fade') {
                start();
                $currentMenu
                  .hide()
                  .clearQueue()
                  .fadeIn(settings.duration, function () {
                    $.proxy(module.event.resetStyle, this)();
                    $.proxy(callback, element)();
                  });
              } else {
                module.error(error.transition, settings.transition);
              }
            }
          },
          hide(callback, $subMenu) {
            const $currentMenu = $subMenu || $menu;
            const duration = $subMenu
              ? settings.duration * 0.9
              : settings.duration;
            const start = $subMenu
              ? function () {}
              : function () {
                  if (module.can.click()) {
                    module.unbind.intent();
                  }
                  module.focusSearch();
                  module.remove.active();
                };
            callback = callback || function () {};
            if (
              module.is.visible($currentMenu) ||
              module.is.animating($currentMenu)
            ) {
              module.verbose('Doing menu hide animation', $currentMenu);

              if (settings.transition == 'none') {
                $.proxy(callback, element)();
              } else if (
                $.fn.transition !== undefined &&
                $module.transition('is supported')
              ) {
                $currentMenu.transition({
                  animation: `${settings.transition} out`,
                  duration: settings.duration,
                  debug: settings.debug,
                  verbose: settings.verbose,
                  queue: true,
                  onStart: start,
                  onComplete() {
                    $.proxy(callback, element)();
                  }
                });
              } else if (settings.transition == 'slide down') {
                start();
                $currentMenu
                  .show()
                  .clearQueue()
                  .children()
                  .clearQueue()
                  .css('opacity', 1)
                  .animate(
                    {
                      opacity: 0
                    },
                    100,
                    'easeOutQuad',
                    module.event.resetStyle
                  )
                  .end()
                  .delay(50)
                  .slideUp(100, 'easeOutQuad', function () {
                    $.proxy(module.event.resetStyle, this)();
                    $.proxy(callback, element)();
                  });
              } else if (settings.transition == 'fade') {
                start();
                $currentMenu
                  .show()
                  .clearQueue()
                  .fadeOut(150, function () {
                    $.proxy(module.event.resetStyle, this)();
                    $.proxy(callback, element)();
                  });
              } else {
                module.error(error.transition);
              }
            }
          }
        },

        delay: {
          show() {
            module.verbose('Delaying show event to ensure user intent');
            clearTimeout(module.timer);
            module.timer = setTimeout(module.show, settings.delay.show);
          },
          hide() {
            module.verbose('Delaying hide event to ensure user intent');
            clearTimeout(module.timer);
            module.timer = setTimeout(module.hide, settings.delay.hide);
          }
        },

        setting(name, value) {
          module.debug('Changing setting', name, value);
          if ($.isPlainObject(name)) {
            $.extend(true, settings, name);
          } else if (value !== undefined) {
            settings[name] = value;
          } else {
            return settings[name];
          }
        },
        internal(name, value) {
          if ($.isPlainObject(name)) {
            $.extend(true, module, name);
          } else if (value !== undefined) {
            module[name] = value;
          } else {
            return module[name];
          }
        },
        debug() {
          if (settings.debug) {
            if (settings.performance) {
              module.performance.log(arguments);
            } else {
              module.debug = Function.prototype.bind.call(
                console.info,
                console,
                `${settings.name}:`
              );
              module.debug.apply(console, arguments);
            }
          }
        },
        verbose() {
          if (settings.verbose && settings.debug) {
            if (settings.performance) {
              module.performance.log(arguments);
            } else {
              module.verbose = Function.prototype.bind.call(
                console.info,
                console,
                `${settings.name}:`
              );
              module.verbose.apply(console, arguments);
            }
          }
        },
        error() {
          module.error = Function.prototype.bind.call(
            console.error,
            console,
            `${settings.name}:`
          );
          module.error.apply(console, arguments);
        },
        performance: {
          log(message) {
            let currentTime;
            let executionTime;
            let previousTime;
            if (settings.performance) {
              currentTime = new Date().getTime();
              previousTime = time || currentTime;
              executionTime = currentTime - previousTime;
              time = currentTime;
              performance.push({
                Name: message[0],
                Arguments: [].slice.call(message, 1) || '',
                Element: element,
                'Execution Time': executionTime
              });
            }
            clearTimeout(module.performance.timer);
            module.performance.timer = setTimeout(
              module.performance.display,
              100
            );
          },
          display() {
            let title = `${settings.name}:`;
            let totalTime = 0;
            time = false;
            clearTimeout(module.performance.timer);
            $.each(performance, function (index, data) {
              totalTime += data['Execution Time'];
            });
            title += ` ${totalTime}ms`;
            if (moduleSelector) {
              title += ` '${moduleSelector}'`;
            }
            if (
              (console.group !== undefined || console.table !== undefined) &&
              performance.length > 0
            ) {
              console.groupCollapsed(title);
              if (console.table) {
                console.table(performance);
              } else {
                $.each(performance, function (index, data) {
                  console.log(`${data.Name}: ${data['Execution Time']}ms`);
                });
              }
              console.groupEnd();
            }
            performance = [];
          }
        },
        invoke(query, passedArguments, context) {
          let object = instance;
          let maxDepth;
          let found;
          let response;
          passedArguments = passedArguments || queryArguments;
          context = element || context;
          if (typeof query === 'string' && object !== undefined) {
            query = query.split(/[\. ]/);
            maxDepth = query.length - 1;
            $.each(query, function (depth, value) {
              const camelCaseValue =
                depth != maxDepth
                  ? value +
                    query[depth + 1].charAt(0).toUpperCase() +
                    query[depth + 1].slice(1)
                  : query;
              if (
                $.isPlainObject(object[camelCaseValue]) &&
                depth != maxDepth
              ) {
                object = object[camelCaseValue];
              } else if (object[camelCaseValue] !== undefined) {
                found = object[camelCaseValue];
                return false;
              } else if ($.isPlainObject(object[value]) && depth != maxDepth) {
                object = object[value];
              } else if (object[value] !== undefined) {
                found = object[value];
                return false;
              } else {
                module.error(error.method, query);
                return false;
              }
            });
          }
          if ($.isFunction(found)) {
            response = found.apply(context, passedArguments);
          } else if (found !== undefined) {
            response = found;
          }
          if ($.isArray(returnedValue)) {
            returnedValue.push(response);
          } else if (returnedValue !== undefined) {
            returnedValue = [returnedValue, response];
          } else if (response !== undefined) {
            returnedValue = response;
          }
          return found;
        }
      };

      if (methodInvoked) {
        if (instance === undefined) {
          module.initialize();
        }
        module.invoke(query);
      } else {
        if (instance !== undefined) {
          module.destroy();
        }
        module.initialize();
      }
    });

    return returnedValue !== undefined ? returnedValue : this;
  };

  $.fn.dropdown.settings = {
    debug: false,
    verbose: true,
    performance: true,

    on: 'click',
    action: 'activate',

    allowTab: true,
    fullTextSearch: true,
    preserveHTML: true,

    delay: {
      show: 200,
      hide: 300,
      touch: 50
    },

    transition: 'slide down',
    duration: 250,

    /* Callbacks */

    onChange(value, text) {},
    onShow() {},
    onHide() {},

    /* Component */

    name: 'Dropdown',
    namespace: 'dropdown',

    error: {
      action: 'You called a dropdown action that was not defined',
      method: 'The method you called is not defined.',
      transition: 'The requested transition was not found'
    },

    metadata: {
      defaultText: 'defaultText',
      defaultValue: 'defaultValue',
      text: 'text',
      value: 'value'
    },

    selector: {
      dropdown: '.ui.dropdown',
      text: '> .text:not(.icon)',
      input: '> input[type="hidden"], > select',
      search: '> input.search, .menu > .search > input, .menu > input.search',
      menu: '.menu',
      item: '.item'
    },

    className: {
      active: 'active',
      animating: 'animating',
      disabled: 'disabled',
      dropdown: 'ui dropdown',
      filtered: 'filtered',
      menu: 'menu',
      placeholder: 'default',
      search: 'search',
      selected: 'selected',
      selection: 'selection',
      visible: 'visible'
    }
  };

  /* Templates */
  $.fn.dropdown.settings.templates = {
    menu(select) {
      const placeholder = select.placeholder || false;
      const values = select.values || {};
      let html = '';
      $.each(select.values, function (value, name) {
        html += `<div class="item" data-value="${value}">${name}</div>`;
      });
      return html;
    },
    dropdown(select) {
      const placeholder = select.placeholder || false;
      const values = select.values || {};
      let html = '';
      html += '<i class="dropdown icon"></i>';
      if (select.placeholder) {
        html += `<div class="default text">${placeholder}</div>`;
      } else {
        html += '<div class="text"></div>';
      }
      html += '<div class="menu">';
      $.each(select.values, function (value, name) {
        html += `<div class="item" data-value="${value}">${name}</div>`;
      });
      html += '</div>';
      return html;
    }
  };

  /* Dependencies */
  $.extend($.easing, {
    easeOutQuad(x, t, b, c, d) {
      return -c * (t /= d) * (t - 2) + b;
    }
  });
})(jQuery, window, document);
/*
 * # Semantic - Dimmer
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Copyright 2014 Contributor
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */

(function ($, window, document, undefined) {
  $.fn.dimmer = function (parameters) {
    const $allModules = $(this);
    let time = new Date().getTime();
    let performance = [];
    const query = arguments[0];
    const methodInvoked = typeof query === 'string';
    const queryArguments = [].slice.call(arguments, 1);
    let returnedValue;

    $allModules.each(function () {
      const settings = $.isPlainObject(parameters)
        ? $.extend(true, {}, $.fn.dimmer.settings, parameters)
        : $.extend({}, $.fn.dimmer.settings);
      const { selector } = settings;
      const { namespace } = settings;
      const { className } = settings;
      const { error } = settings;
      const eventNamespace = `.${namespace}`;
      const moduleNamespace = `module-${namespace}`;
      const moduleSelector = $allModules.selector || '';
      const clickEvent =
        'ontouchstart' in document.documentElement ? 'touchstart' : 'click';
      const $module = $(this);
      let $dimmer;
      let $dimmable;
      const element = this;
      let instance = $module.data(moduleNamespace);
      let module;

      module = {
        preinitialize() {
          if (module.is.dimmer()) {
            $dimmable = $module.parent();
            $dimmer = $module;
          } else {
            $dimmable = $module;
            if (module.has.dimmer()) {
              if (settings.dimmerName) {
                $dimmer = $dimmable
                  .children(selector.dimmer)
                  .filter(`.${settings.dimmerName}`);
              } else {
                $dimmer = $dimmable.children(selector.dimmer);
              }
            } else {
              $dimmer = module.create();
            }
          }
        },

        initialize() {
          module.debug('Initializing dimmer', settings);
          if (settings.on == 'hover') {
            $dimmable
              .on(`mouseenter${eventNamespace}`, module.show)
              .on(`mouseleave${eventNamespace}`, module.hide);
          } else if (settings.on == 'click') {
            $dimmable.on(clickEvent + eventNamespace, module.toggle);
          }
          if (module.is.page()) {
            module.debug('Setting as a page dimmer', $dimmable);
            module.set.pageDimmer();
          }

          if (module.is.closable()) {
            module.verbose('Adding dimmer close event', $dimmer);
            $dimmer.on(clickEvent + eventNamespace, module.event.click);
          }
          module.set.dimmable();
          module.instantiate();
        },

        instantiate() {
          module.verbose('Storing instance of module', module);
          instance = module;
          $module.data(moduleNamespace, instance);
        },

        destroy() {
          module.verbose('Destroying previous module', $dimmer);
          $module.removeData(moduleNamespace);
          $dimmable.off(eventNamespace);
          $dimmer.off(eventNamespace);
        },

        event: {
          click(event) {
            module.verbose('Determining if event occured on dimmer', event);
            if (
              $dimmer.find(event.target).size() === 0 ||
              $(event.target).is(selector.content)
            ) {
              module.hide();
              event.stopImmediatePropagation();
            }
          }
        },

        addContent(element) {
          const $content = $(element);
          module.debug('Add content to dimmer', $content);
          if ($content.parent()[0] !== $dimmer[0]) {
            $content.detach().appendTo($dimmer);
          }
        },

        create() {
          const $element = $(settings.template.dimmer());
          if (settings.variation) {
            module.debug('Creating dimmer with variation', settings.variation);
            $element.addClass(className.variation);
          }
          if (settings.dimmerName) {
            module.debug('Creating named dimmer', settings.dimmerName);
            $element.addClass(settings.dimmerName);
          }
          $element.appendTo($dimmable);
          return $element;
        },

        show(callback) {
          callback = $.isFunction(callback) ? callback : function () {};
          module.debug('Showing dimmer', $dimmer, settings);
          if (
            (!module.is.dimmed() || module.is.animating()) &&
            module.is.enabled()
          ) {
            module.animate.show(callback);
            $.proxy(settings.onShow, element)();
            $.proxy(settings.onChange, element)();
          } else {
            module.debug('Dimmer is already shown or disabled');
          }
        },

        hide(callback) {
          callback = $.isFunction(callback) ? callback : function () {};
          if (module.is.dimmed() || module.is.animating()) {
            module.debug('Hiding dimmer', $dimmer);
            module.animate.hide(callback);
            $.proxy(settings.onHide, element)();
            $.proxy(settings.onChange, element)();
          } else {
            module.debug('Dimmer is not visible');
          }
        },

        toggle() {
          module.verbose('Toggling dimmer visibility', $dimmer);
          if (!module.is.dimmed()) {
            module.show();
          } else {
            module.hide();
          }
        },

        animate: {
          show(callback) {
            callback = $.isFunction(callback) ? callback : function () {};
            if (
              settings.useCSS &&
              $.fn.transition !== undefined &&
              $dimmer.transition('is supported')
            ) {
              $dimmer.transition({
                animation: `${settings.transition} in`,
                queue: false,
                duration: module.get.duration(),
                onStart() {
                  module.set.dimmed();
                },
                onComplete() {
                  module.set.active();
                  callback();
                }
              });
            } else {
              module.verbose('Showing dimmer animation with javascript');
              module.set.dimmed();
              $dimmer
                .stop()
                .css({
                  opacity: 0,
                  width: '100%',
                  height: '100%'
                })
                .fadeTo(module.get.duration(), 1, function () {
                  $dimmer.removeAttr('style');
                  module.set.active();
                  callback();
                });
            }
          },
          hide(callback) {
            callback = $.isFunction(callback) ? callback : function () {};
            if (
              settings.useCSS &&
              $.fn.transition !== undefined &&
              $dimmer.transition('is supported')
            ) {
              module.verbose('Hiding dimmer with css');
              $dimmer.transition({
                animation: `${settings.transition} out`,
                queue: false,
                duration: module.get.duration(),
                onStart() {
                  module.remove.dimmed();
                },
                onComplete() {
                  module.remove.active();
                  callback();
                }
              });
            } else {
              module.verbose('Hiding dimmer with javascript');
              module.remove.dimmed();
              $dimmer.stop().fadeOut(module.get.duration(), function () {
                module.remove.active();
                $dimmer.removeAttr('style');
                callback();
              });
            }
          }
        },

        get: {
          dimmer() {
            return $dimmer;
          },
          duration() {
            if (typeof settings.duration === 'object') {
              if (module.is.active()) {
                return settings.duration.hide;
              }
              return settings.duration.show;
            }
            return settings.duration;
          }
        },

        has: {
          dimmer() {
            if (settings.dimmerName) {
              return (
                $module
                  .children(selector.dimmer)
                  .filter(`.${settings.dimmerName}`)
                  .size() > 0
              );
            }
            return $module.children(selector.dimmer).size() > 0;
          }
        },

        is: {
          active() {
            return $dimmer.hasClass(className.active);
          },
          animating() {
            return (
              $dimmer.is(':animated') || $dimmer.hasClass(className.animating)
            );
          },
          closable() {
            if (settings.closable == 'auto') {
              if (settings.on == 'hover') {
                return false;
              }
              return true;
            }
            return settings.closable;
          },
          dimmer() {
            return $module.is(selector.dimmer);
          },
          dimmable() {
            return $module.is(selector.dimmable);
          },
          dimmed() {
            return $dimmable.hasClass(className.dimmed);
          },
          disabled() {
            return $dimmable.hasClass(className.disabled);
          },
          enabled() {
            return !module.is.disabled();
          },
          page() {
            return $dimmable.is('body');
          },
          pageDimmer() {
            return $dimmer.hasClass(className.pageDimmer);
          }
        },

        can: {
          show() {
            return !$dimmer.hasClass(className.disabled);
          }
        },

        set: {
          active() {
            $dimmer.addClass(className.active);
          },
          dimmable() {
            $dimmable.addClass(className.dimmable);
          },
          dimmed() {
            $dimmable.addClass(className.dimmed);
          },
          pageDimmer() {
            $dimmer.addClass(className.pageDimmer);
          },
          disabled() {
            $dimmer.addClass(className.disabled);
          }
        },

        remove: {
          active() {
            $dimmer.removeClass(className.active);
          },
          dimmed() {
            $dimmable.removeClass(className.dimmed);
          },
          disabled() {
            $dimmer.removeClass(className.disabled);
          }
        },

        setting(name, value) {
          module.debug('Changing setting', name, value);
          if ($.isPlainObject(name)) {
            $.extend(true, settings, name);
          } else if (value !== undefined) {
            settings[name] = value;
          } else {
            return settings[name];
          }
        },
        internal(name, value) {
          if ($.isPlainObject(name)) {
            $.extend(true, module, name);
          } else if (value !== undefined) {
            module[name] = value;
          } else {
            return module[name];
          }
        },
        debug() {
          if (settings.debug) {
            if (settings.performance) {
              module.performance.log(arguments);
            } else {
              module.debug = Function.prototype.bind.call(
                console.info,
                console,
                `${settings.name}:`
              );
              module.debug.apply(console, arguments);
            }
          }
        },
        verbose() {
          if (settings.verbose && settings.debug) {
            if (settings.performance) {
              module.performance.log(arguments);
            } else {
              module.verbose = Function.prototype.bind.call(
                console.info,
                console,
                `${settings.name}:`
              );
              module.verbose.apply(console, arguments);
            }
          }
        },
        error() {
          module.error = Function.prototype.bind.call(
            console.error,
            console,
            `${settings.name}:`
          );
          module.error.apply(console, arguments);
        },
        performance: {
          log(message) {
            let currentTime;
            let executionTime;
            let previousTime;
            if (settings.performance) {
              currentTime = new Date().getTime();
              previousTime = time || currentTime;
              executionTime = currentTime - previousTime;
              time = currentTime;
              performance.push({
                Name: message[0],
                Arguments: [].slice.call(message, 1) || '',
                Element: element,
                'Execution Time': executionTime
              });
            }
            clearTimeout(module.performance.timer);
            module.performance.timer = setTimeout(
              module.performance.display,
              100
            );
          },
          display() {
            let title = `${settings.name}:`;
            let totalTime = 0;
            time = false;
            clearTimeout(module.performance.timer);
            $.each(performance, function (index, data) {
              totalTime += data['Execution Time'];
            });
            title += ` ${totalTime}ms`;
            if (moduleSelector) {
              title += ` '${moduleSelector}'`;
            }
            if ($allModules.size() > 1) {
              title += `${' ' + '('}${$allModules.size()})`;
            }
            if (
              (console.group !== undefined || console.table !== undefined) &&
              performance.length > 0
            ) {
              console.groupCollapsed(title);
              if (console.table) {
                console.table(performance);
              } else {
                $.each(performance, function (index, data) {
                  console.log(`${data.Name}: ${data['Execution Time']}ms`);
                });
              }
              console.groupEnd();
            }
            performance = [];
          }
        },
        invoke(query, passedArguments, context) {
          let object = instance;
          let maxDepth;
          let found;
          let response;
          passedArguments = passedArguments || queryArguments;
          context = element || context;
          if (typeof query === 'string' && object !== undefined) {
            query = query.split(/[\. ]/);
            maxDepth = query.length - 1;
            $.each(query, function (depth, value) {
              const camelCaseValue =
                depth != maxDepth
                  ? value +
                    query[depth + 1].charAt(0).toUpperCase() +
                    query[depth + 1].slice(1)
                  : query;
              if (
                $.isPlainObject(object[camelCaseValue]) &&
                depth != maxDepth
              ) {
                object = object[camelCaseValue];
              } else if (object[camelCaseValue] !== undefined) {
                found = object[camelCaseValue];
                return false;
              } else if ($.isPlainObject(object[value]) && depth != maxDepth) {
                object = object[value];
              } else if (object[value] !== undefined) {
                found = object[value];
                return false;
              } else {
                return false;
              }
            });
          }
          if ($.isFunction(found)) {
            response = found.apply(context, passedArguments);
          } else if (found !== undefined) {
            response = found;
          }
          if ($.isArray(returnedValue)) {
            returnedValue.push(response);
          } else if (returnedValue !== undefined) {
            returnedValue = [returnedValue, response];
          } else if (response !== undefined) {
            returnedValue = response;
          }
          return found;
        }
      };

      module.preinitialize();

      if (methodInvoked) {
        if (instance === undefined) {
          module.initialize();
        }
        module.invoke(query);
      } else {
        if (instance !== undefined) {
          module.destroy();
        }
        module.initialize();
      }
    });

    return returnedValue !== undefined ? returnedValue : this;
  };

  $.fn.dimmer.settings = {
    name: 'Dimmer',
    namespace: 'dimmer',

    debug: false,
    verbose: true,
    performance: true,

    dimmerName: false,
    variation: false,
    closable: 'auto',
    transition: 'fade',
    useCSS: true,
    on: false,

    duration: {
      show: 500,
      hide: 500
    },

    onChange() {},
    onShow() {},
    onHide() {},

    error: {
      method: 'The method you called is not defined.'
    },

    selector: {
      dimmable: '.dimmable',
      dimmer: '.ui.dimmer',
      content: '.ui.dimmer > .content, .ui.dimmer > .content > .center'
    },

    template: {
      dimmer() {
        return $('<div />').attr('class', 'ui dimmer');
      }
    },

    className: {
      active: 'active',
      animating: 'animating',
      dimmable: 'dimmable',
      dimmed: 'dimmed',
      disabled: 'disabled',
      hide: 'hide',
      pageDimmer: 'page',
      show: 'show'
    }
  };
})(jQuery, window, document);
/*
 * # Semantic - Popup
 * http://github.com/jlukic/semantic-ui/
 *
 *
 * Copyright 2014 Contributor
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */

(function ($, window, document, undefined) {
  $.fn.popup = function (parameters) {
    const $allModules = $(this);
    const $document = $(document);
    const moduleSelector = $allModules.selector || '';
    const hasTouch = 'ontouchstart' in document.documentElement;
    let time = new Date().getTime();
    let performance = [];
    const query = arguments[0];
    const methodInvoked = typeof query === 'string';
    const queryArguments = [].slice.call(arguments, 1);
    let returnedValue;
    $allModules.each(function () {
      const settings = $.isPlainObject(parameters)
        ? $.extend(true, {}, $.fn.popup.settings, parameters)
        : $.extend({}, $.fn.popup.settings);
      const { selector } = settings;
      const { className } = settings;
      const { error } = settings;
      const { metadata } = settings;
      const { namespace } = settings;
      const eventNamespace = `.${settings.namespace}`;
      const moduleNamespace = `module-${namespace}`;
      const $module = $(this);
      const $context = $(settings.context);
      const $target = settings.target ? $(settings.target) : $module;
      const $window = $(window);
      const $body = $('body');
      let $popup;
      let $offsetParent;
      let searchDepth = 0;
      let triedPositions = false;
      const element = this;
      let instance = $module.data(moduleNamespace);
      let module;

      module = {
        // binds events
        initialize() {
          module.debug('Initializing module', $module);
          module.refresh();
          if (settings.on == 'click') {
            $module.on(`click${eventNamespace}`, module.toggle);
          } else if (module.get.startEvent()) {
            $module
              .on(module.get.startEvent() + eventNamespace, module.event.start)
              .on(module.get.endEvent() + eventNamespace, module.event.end);
          }
          if (settings.target) {
            module.debug('Target set to element', $target);
          }
          $window.on(`resize${eventNamespace}`, module.event.resize);
          if (!module.exists()) {
            module.create();
          } else if (settings.hoverable) {
            module.bind.popup();
          }
          module.instantiate();
        },

        instantiate() {
          module.verbose('Storing instance of module', module);
          instance = module;
          $module.data(moduleNamespace, instance);
        },

        refresh() {
          if (settings.popup) {
            $popup = $(settings.popup);
          } else if (settings.inline) {
            $popup = $target.next(settings.selector.popup);
          }
          if (settings.popup) {
            $popup.addClass(className.loading);
            $offsetParent = $popup.offsetParent();
            $popup.removeClass(className.loading);
          } else {
            $offsetParent = settings.inline ? $target.offsetParent() : $body;
          }
          if ($offsetParent.is('html')) {
            module.debug('Page is popups offset parent');
            $offsetParent = $body;
          }
        },

        reposition() {
          module.refresh();
          module.set.position();
        },

        destroy() {
          module.debug('Destroying previous module');
          if ($popup && !settings.preserve) {
            module.removePopup();
          }
          $module.off(eventNamespace).removeData(moduleNamespace);
        },

        event: {
          start(event) {
            const delay = $.isPlainObject(settings.delay)
              ? settings.delay.show
              : settings.delay;
            clearTimeout(module.hideTimer);
            module.showTimer = setTimeout(function () {
              if (
                module.is.hidden() &&
                !(module.is.active() && module.is.dropdown())
              ) {
                module.show();
              }
            }, delay);
          },
          end() {
            const delay = $.isPlainObject(settings.delay)
              ? settings.delay.hide
              : settings.delay;
            clearTimeout(module.showTimer);
            module.hideTimer = setTimeout(function () {
              if (module.is.visible()) {
                module.hide();
              }
            }, delay);
          },
          resize() {
            if (module.is.visible()) {
              module.set.position();
            }
          }
        },

        // generates popup html from metadata
        create() {
          let html = $module.data(metadata.html) || settings.html;
          const variation =
            $module.data(metadata.variation) || settings.variation;
          const title = $module.data(metadata.title) || settings.title;
          const content =
            $module.data(metadata.content) ||
            $module.attr('title') ||
            settings.content;
          if (html || content || title) {
            module.debug('Creating pop-up html');
            if (!html) {
              html = settings.templates.popup({
                title,
                content
              });
            }
            $popup = $('<div/>')
              .addClass(className.popup)
              .addClass(variation)
              .html(html);
            if (variation) {
              $popup.addClass(variation);
            }
            if (settings.inline) {
              module.verbose('Inserting popup element inline', $popup);
              $popup.insertAfter($module);
            } else {
              module.verbose('Appending popup element to body', $popup);
              $popup.appendTo($context);
            }
            if (settings.hoverable) {
              module.bind.popup();
            }
            $.proxy(settings.onCreate, $popup)(element);
          } else if ($target.next(settings.selector.popup).size() !== 0) {
            module.verbose('Pre-existing popup found, reverting to inline');
            settings.inline = true;
            module.refresh();
            if (settings.hoverable) {
              module.bind.popup();
            }
          } else {
            module.debug('No content specified skipping display', element);
          }
        },

        // determines popup state
        toggle() {
          module.debug('Toggling pop-up');
          if (module.is.hidden()) {
            module.debug('Popup is hidden, showing pop-up');
            module.unbind.close();
            module.hideAll();
            module.show();
          } else {
            module.debug('Popup is visible, hiding pop-up');
            module.hide();
          }
        },

        show(callback) {
          callback = $.isFunction(callback) ? callback : function () {};
          module.debug('Showing pop-up', settings.transition);
          if (!settings.preserve && !settings.popup) {
            module.refresh();
          }
          if (!module.exists()) {
            module.create();
          }
          if ($popup && module.set.position()) {
            module.save.conditions();
            module.animate.show(callback);
          }
        },

        hide(callback) {
          callback = $.isFunction(callback) ? callback : function () {};
          module.remove.visible();
          module.unbind.close();
          if (module.is.visible()) {
            module.restore.conditions();
            module.animate.hide(callback);
          }
        },

        hideAll() {
          $(selector.popup).filter(':visible').popup('hide');
        },

        hideGracefully(event) {
          // don't close on clicks inside popup
          if (event && $(event.target).closest(selector.popup).size() === 0) {
            module.debug('Click occurred outside popup hiding popup');
            module.hide();
          } else {
            module.debug('Click was inside popup, keeping popup open');
          }
        },

        exists() {
          if (!$popup) {
            return false;
          }
          if (settings.inline || settings.popup) {
            return $popup.size() !== 0;
          }
          return $popup.closest($context).size();
        },

        removePopup() {
          module.debug('Removing popup');
          $.proxy(settings.onRemove, $popup)(element);
          $popup.remove();
        },

        save: {
          conditions() {
            module.cache = {
              title: $module.attr('title')
            };
            if (module.cache.title) {
              $module.removeAttr('title');
            }
            module.verbose('Saving original attributes', module.cache.title);
          }
        },
        restore: {
          conditions() {
            element.blur();
            if (module.cache && module.cache.title) {
              $module.attr('title', module.cache.title);
              module.verbose(
                'Restoring original attributes',
                module.cache.title
              );
            }
            return true;
          }
        },
        animate: {
          show(callback) {
            callback = $.isFunction(callback) ? callback : function () {};
            if (
              settings.transition &&
              $.fn.transition !== undefined &&
              $module.transition('is supported')
            ) {
              module.set.visible();
              $popup.transition({
                animation: `${settings.transition} in`,
                queue: false,
                debug: settings.debug,
                verbose: settings.verbose,
                duration: settings.duration,
                onComplete() {
                  module.bind.close();
                  $.proxy(callback, $popup)(element);
                  $.proxy(settings.onVisible, $popup)(element);
                }
              });
            } else {
              module.set.visible();
              $popup
                .stop()
                .fadeIn(settings.duration, settings.easing, function () {
                  module.bind.close();
                  $.proxy(callback, element)();
                });
            }
            $.proxy(settings.onShow, $popup)(element);
          },
          hide(callback) {
            callback = $.isFunction(callback) ? callback : function () {};
            module.debug('Hiding pop-up');
            if (
              settings.transition &&
              $.fn.transition !== undefined &&
              $module.transition('is supported')
            ) {
              $popup.transition({
                animation: `${settings.transition} out`,
                queue: false,
                duration: settings.duration,
                debug: settings.debug,
                verbose: settings.verbose,
                onComplete() {
                  module.reset();
                  $.proxy(callback, $popup)(element);
                  $.proxy(settings.onHidden, $popup)(element);
                }
              });
            } else {
              $popup
                .stop()
                .fadeOut(settings.duration, settings.easing, function () {
                  module.reset();
                  callback();
                });
            }
            $.proxy(settings.onHide, $popup)(element);
          }
        },

        get: {
          startEvent() {
            if (settings.on == 'hover') {
              return 'mouseenter';
            }
            if (settings.on == 'focus') {
              return 'focus';
            }
            return false;
          },
          endEvent() {
            if (settings.on == 'hover') {
              return 'mouseleave';
            }
            if (settings.on == 'focus') {
              return 'blur';
            }
            return false;
          },
          offstagePosition(position) {
            var position = position || false;
            const boundary = {
              top: $(window).scrollTop(),
              bottom: $(window).scrollTop() + $(window).height(),
              left: 0,
              right: $(window).width()
            };
            const popup = {
              width: $popup.width(),
              height: $popup.height(),
              offset: $popup.offset()
            };
            let offstage = {};
            const offstagePositions = [];
            if (popup.offset && position) {
              module.verbose('Checking if outside viewable area', popup.offset);
              offstage = {
                top: popup.offset.top < boundary.top,
                bottom: popup.offset.top + popup.height > boundary.bottom,
                right: popup.offset.left + popup.width > boundary.right,
                left: popup.offset.left < boundary.left
              };
            }
            // return only boundaries that have been surpassed
            $.each(offstage, function (direction, isOffstage) {
              if (isOffstage) {
                offstagePositions.push(direction);
              }
            });
            return offstagePositions.length > 0
              ? offstagePositions.join(' ')
              : false;
          },
          positions() {
            return {
              'top left': false,
              'top center': false,
              'top right': false,
              'bottom left': false,
              'bottom center': false,
              'bottom right': false,
              'left center': false,
              'right center': false
            };
          },
          nextPosition(position) {
            const positions = position.split(' ');
            const verticalPosition = positions[0];
            const horizontalPosition = positions[1];
            const opposite = {
              top: 'bottom',
              bottom: 'top',
              left: 'right',
              right: 'left'
            };
            const adjacent = {
              left: 'center',
              center: 'right',
              right: 'left'
            };
            const backup = {
              'top left': 'top center',
              'top center': 'top right',
              'top right': 'right center',
              'right center': 'bottom right',
              'bottom right': 'bottom center',
              'bottom center': 'bottom left',
              'bottom left': 'left center',
              'left center': 'top left'
            };
            const adjacentsAvailable =
              verticalPosition == 'top' || verticalPosition == 'bottom';
            let oppositeTried = false;
            let adjacentTried = false;
            let nextPosition = false;
            if (!triedPositions) {
              module.verbose('All available positions available');
              triedPositions = module.get.positions();
            }

            module.debug('Recording last position tried', position);
            triedPositions[position] = true;

            if (settings.prefer === 'opposite') {
              nextPosition = [opposite[verticalPosition], horizontalPosition];
              nextPosition = nextPosition.join(' ');
              oppositeTried = triedPositions[nextPosition] === true;
              module.debug('Trying opposite strategy', nextPosition);
            }
            if (settings.prefer === 'adjacent' && adjacentsAvailable) {
              nextPosition = [verticalPosition, adjacent[horizontalPosition]];
              nextPosition = nextPosition.join(' ');
              adjacentTried = triedPositions[nextPosition] === true;
              module.debug('Trying adjacent strategy', nextPosition);
            }
            if (adjacentTried || oppositeTried) {
              module.debug('Using backup position', nextPosition);
              nextPosition = backup[position];
            }
            return nextPosition;
          }
        },

        set: {
          position(position, arrowOffset) {
            const windowWidth = $(window).width();
            const windowHeight = $(window).height();
            const targetWidth = $target.outerWidth();
            const targetHeight = $target.outerHeight();
            const popupWidth = $popup.outerWidth();
            const popupHeight = $popup.outerHeight();
            const parentWidth = $offsetParent.outerWidth();
            const parentHeight = $offsetParent.outerHeight();
            let { distanceAway } = settings;
            const targetElement = $target[0];
            const marginTop = settings.inline
              ? parseInt(
                  window
                    .getComputedStyle(targetElement)
                    .getPropertyValue('margin-top'),
                  10
                )
              : 0;
            const marginLeft = settings.inline
              ? parseInt(
                  window
                    .getComputedStyle(targetElement)
                    .getPropertyValue('margin-left'),
                  10
                )
              : 0;
            const target =
              settings.inline || settings.popup
                ? $target.position()
                : $target.offset();
            let positioning;
            let offstagePosition;
            position =
              position || $module.data(metadata.position) || settings.position;
            arrowOffset =
              arrowOffset || $module.data(metadata.offset) || settings.offset;

            if (searchDepth == settings.maxSearchDepth && settings.lastResort) {
              module.debug(
                'Using last resort position to display',
                settings.lastResort
              );
              position = settings.lastResort;
            }

            if (settings.inline) {
              module.debug('Adding targets margin to calculation');
              if (position == 'left center' || position == 'right center') {
                arrowOffset += marginTop;
                distanceAway += -marginLeft;
              } else if (
                position == 'top left' ||
                position == 'top center' ||
                position == 'top right'
              ) {
                arrowOffset += marginLeft;
                distanceAway -= marginTop;
              } else {
                arrowOffset += marginLeft;
                distanceAway += marginTop;
              }
            }
            module.debug('Calculating popup positioning', position);
            switch (position) {
              case 'top left':
                positioning = {
                  top: 'auto',
                  bottom: parentHeight - target.top + distanceAway,
                  left: target.left + arrowOffset,
                  right: 'auto'
                };
                break;
              case 'top center':
                positioning = {
                  bottom: parentHeight - target.top + distanceAway,
                  left:
                    target.left +
                    targetWidth / 2 -
                    popupWidth / 2 +
                    arrowOffset,
                  top: 'auto',
                  right: 'auto'
                };
                break;
              case 'top right':
                positioning = {
                  bottom: parentHeight - target.top + distanceAway,
                  right: parentWidth - target.left - targetWidth - arrowOffset,
                  top: 'auto',
                  left: 'auto'
                };
                break;
              case 'left center':
                positioning = {
                  top:
                    target.top +
                    targetHeight / 2 -
                    popupHeight / 2 +
                    arrowOffset,
                  right: parentWidth - target.left + distanceAway,
                  left: 'auto',
                  bottom: 'auto'
                };
                break;
              case 'right center':
                positioning = {
                  top:
                    target.top +
                    targetHeight / 2 -
                    popupHeight / 2 +
                    arrowOffset,
                  left: target.left + targetWidth + distanceAway,
                  bottom: 'auto',
                  right: 'auto'
                };
                break;
              case 'bottom left':
                positioning = {
                  top: target.top + targetHeight + distanceAway,
                  left: target.left + arrowOffset,
                  bottom: 'auto',
                  right: 'auto'
                };
                break;
              case 'bottom center':
                positioning = {
                  top: target.top + targetHeight + distanceAway,
                  left:
                    target.left +
                    targetWidth / 2 -
                    popupWidth / 2 +
                    arrowOffset,
                  bottom: 'auto',
                  right: 'auto'
                };
                break;
              case 'bottom right':
                positioning = {
                  top: target.top + targetHeight + distanceAway,
                  right: parentWidth - target.left - targetWidth - arrowOffset,
                  left: 'auto',
                  bottom: 'auto'
                };
                break;
            }
            if (positioning === undefined) {
              module.error(error.invalidPosition, position);
            }

            // tentatively place on stage
            $popup
              .css(positioning)
              .removeClass(className.position)
              .addClass(position)
              .addClass(className.loading);
            // check if is offstage
            offstagePosition = module.get.offstagePosition(position);

            // recursively find new positioning
            if (offstagePosition) {
              module.debug('Popup cant fit into viewport', offstagePosition);
              if (searchDepth < settings.maxSearchDepth) {
                searchDepth++;
                position = module.get.nextPosition(position);
                module.debug('Trying new position', position);
                return $popup ? module.set.position(position) : false;
              }
              if (!settings.lastResort) {
                module.debug('Popup could not find a position in view', $popup);
                module.error(error.cannotPlace);
                module.remove.attempts();
                module.remove.loading();
                module.reset();
                return false;
              }
            }

            module.debug('Position is on stage', position);
            module.remove.attempts();
            module.set.fluidWidth();
            module.remove.loading();
            return true;
          },

          fluidWidth() {
            if (settings.setFluidWidth && $popup.hasClass(className.fluid)) {
              $popup.css('width', $offsetParent.width());
            }
          },

          visible() {
            $module.addClass(className.visible);
          }
        },

        remove: {
          loading() {
            $popup.removeClass(className.loading);
          },
          visible() {
            $module.removeClass(className.visible);
          },
          attempts() {
            module.verbose('Resetting all searched positions');
            searchDepth = 0;
            triedPositions = false;
          }
        },

        bind: {
          popup() {
            module.verbose('Allowing hover events on popup to prevent closing');
            if ($popup && $popup.size() > 0) {
              $popup
                .on(`mouseenter${eventNamespace}`, module.event.start)
                .on(`mouseleave${eventNamespace}`, module.event.end);
            }
          },
          close() {
            if (
              settings.hideOnScroll === true ||
              (settings.hideOnScroll == 'auto' && settings.on != 'click')
            ) {
              $document
                .one(`touchmove${eventNamespace}`, module.hideGracefully)
                .one(`scroll${eventNamespace}`, module.hideGracefully);
              $context
                .one(`touchmove${eventNamespace}`, module.hideGracefully)
                .one(`scroll${eventNamespace}`, module.hideGracefully);
            }
            if (settings.on == 'click' && settings.closable) {
              module.verbose('Binding popup close event to document');
              $document.on(`click${eventNamespace}`, function (event) {
                module.verbose('Pop-up clickaway intent detected');
                $.proxy(module.hideGracefully, element)(event);
              });
            }
          }
        },

        unbind: {
          close() {
            if (
              settings.hideOnScroll === true ||
              (settings.hideOnScroll == 'auto' && settings.on != 'click')
            ) {
              $document.off(`scroll${eventNamespace}`, module.hide);
              $context.off(`scroll${eventNamespace}`, module.hide);
            }
            if (settings.on == 'click' && settings.closable) {
              module.verbose('Removing close event from document');
              $document.off(`click${eventNamespace}`);
            }
          }
        },

        is: {
          active() {
            return $module.hasClass(className.active);
          },
          animating() {
            return (
              ($popup && $popup.is(':animated')) ||
              $popup.hasClass(className.animating)
            );
          },
          visible() {
            return $popup && $popup.is(':visible');
          },
          dropdown() {
            return $module.hasClass(className.dropdown);
          },
          hidden() {
            return !module.is.visible();
          }
        },

        reset() {
          module.remove.visible();
          if (settings.preserve || settings.popup) {
            if ($.fn.transition !== undefined) {
              $popup.transition('remove transition');
            }
          } else {
            module.removePopup();
          }
        },

        setting(name, value) {
          if ($.isPlainObject(name)) {
            $.extend(true, settings, name);
          } else if (value !== undefined) {
            settings[name] = value;
          } else {
            return settings[name];
          }
        },
        internal(name, value) {
          if ($.isPlainObject(name)) {
            $.extend(true, module, name);
          } else if (value !== undefined) {
            module[name] = value;
          } else {
            return module[name];
          }
        },
        debug() {
          if (settings.debug) {
            if (settings.performance) {
              module.performance.log(arguments);
            } else {
              module.debug = Function.prototype.bind.call(
                console.info,
                console,
                `${settings.name}:`
              );
              module.debug.apply(console, arguments);
            }
          }
        },
        verbose() {
          if (settings.verbose && settings.debug) {
            if (settings.performance) {
              module.performance.log(arguments);
            } else {
              module.verbose = Function.prototype.bind.call(
                console.info,
                console,
                `${settings.name}:`
              );
              module.verbose.apply(console, arguments);
            }
          }
        },
        error() {
          module.error = Function.prototype.bind.call(
            console.error,
            console,
            `${settings.name}:`
          );
          module.error.apply(console, arguments);
        },
        performance: {
          log(message) {
            let currentTime;
            let executionTime;
            let previousTime;
            if (settings.performance) {
              currentTime = new Date().getTime();
              previousTime = time || currentTime;
              executionTime = currentTime - previousTime;
              time = currentTime;
              performance.push({
                Name: message[0],
                Arguments: [].slice.call(message, 1) || '',
                Element: element,
                'Execution Time': executionTime
              });
            }
            clearTimeout(module.performance.timer);
            module.performance.timer = setTimeout(
              module.performance.display,
              100
            );
          },
          display() {
            let title = `${settings.name}:`;
            let totalTime = 0;
            time = false;
            clearTimeout(module.performance.timer);
            $.each(performance, function (index, data) {
              totalTime += data['Execution Time'];
            });
            title += ` ${totalTime}ms`;
            if (moduleSelector) {
              title += ` '${moduleSelector}'`;
            }
            if (
              (console.group !== undefined || console.table !== undefined) &&
              performance.length > 0
            ) {
              console.groupCollapsed(title);
              if (console.table) {
                console.table(performance);
              } else {
                $.each(performance, function (index, data) {
                  console.log(`${data.Name}: ${data['Execution Time']}ms`);
                });
              }
              console.groupEnd();
            }
            performance = [];
          }
        },
        invoke(query, passedArguments, context) {
          let object = instance;
          let maxDepth;
          let found;
          let response;
          passedArguments = passedArguments || queryArguments;
          context = element || context;
          if (typeof query === 'string' && object !== undefined) {
            query = query.split(/[\. ]/);
            maxDepth = query.length - 1;
            $.each(query, function (depth, value) {
              const camelCaseValue =
                depth != maxDepth
                  ? value +
                    query[depth + 1].charAt(0).toUpperCase() +
                    query[depth + 1].slice(1)
                  : query;
              if (
                $.isPlainObject(object[camelCaseValue]) &&
                depth != maxDepth
              ) {
                object = object[camelCaseValue];
              } else if (object[camelCaseValue] !== undefined) {
                found = object[camelCaseValue];
                return false;
              } else if ($.isPlainObject(object[value]) && depth != maxDepth) {
                object = object[value];
              } else if (object[value] !== undefined) {
                found = object[value];
                return false;
              } else {
                return false;
              }
            });
          }
          if ($.isFunction(found)) {
            response = found.apply(context, passedArguments);
          } else if (found !== undefined) {
            response = found;
          }
          if ($.isArray(returnedValue)) {
            returnedValue.push(response);
          } else if (returnedValue !== undefined) {
            returnedValue = [returnedValue, response];
          } else if (response !== undefined) {
            returnedValue = response;
          }
          return found;
        }
      };

      if (methodInvoked) {
        if (instance === undefined) {
          module.initialize();
        }
        module.invoke(query);
      } else {
        if (instance !== undefined) {
          module.destroy();
        }
        module.initialize();
      }
    });

    return returnedValue !== undefined ? returnedValue : this;
  };

  $.fn.popup.settings = {
    name: 'Popup',

    debug: false,
    verbose: true,
    performance: true,
    namespace: 'popup',

    onCreate() {},
    onRemove() {},

    onShow() {},
    onVisible() {},
    onHide() {},
    onHidden() {},

    variation: '',
    content: false,
    html: false,
    title: false,

    on: 'hover',
    closable: true,
    hideOnScroll: 'auto',

    context: 'body',

    position: 'top left',
    prefer: 'opposite',
    lastResort: false,

    delay: {
      show: 30,
      hide: 0
    },

    setFluidWidth: true,

    target: false,
    popup: false,
    inline: false,
    preserve: true,
    hoverable: false,

    duration: 200,
    easing: 'easeOutQuint',
    transition: 'scale',

    distanceAway: 0,
    offset: 0,
    maxSearchDepth: 20,

    error: {
      invalidPosition: 'The position you specified is not a valid position',
      cannotPlace: 'No visible position could be found for the popup',
      method: 'The method you called is not defined.'
    },

    metadata: {
      content: 'content',
      html: 'html',
      offset: 'offset',
      position: 'position',
      title: 'title',
      variation: 'variation'
    },

    className: {
      active: 'active',
      animating: 'animating',
      dropdown: 'dropdown',
      fluid: 'fluid',
      loading: 'loading',
      popup: 'ui popup',
      position: 'top left center bottom right',
      visible: 'visible'
    },

    selector: {
      popup: '.ui.popup'
    },

    templates: {
      escape(string) {
        const badChars = /[&<>"'`]/g;
        const shouldEscape = /[&<>"'`]/;
        const escape = {
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#x27;',
          '`': '&#x60;'
        };
        const escapedChar = function (chr) {
          return escape[chr];
        };
        if (shouldEscape.test(string)) {
          return string.replace(badChars, escapedChar);
        }
        return string;
      },
      popup(text) {
        let html = '';
        const { escape } = $.fn.popup.settings.templates;
        if (typeof text !== undefined) {
          if (typeof text.title !== undefined && text.title) {
            text.title = escape(text.title);
            html += `<div class="header">${text.title}</div>`;
          }
          if (typeof text.content !== undefined && text.content) {
            text.content = escape(text.content);
            html += `<div class="content">${text.content}</div>`;
          }
        }
        return html;
      }
    }
  };

  // Adds easing
  $.extend($.easing, {
    easeOutQuad(x, t, b, c, d) {
      return -c * (t /= d) * (t - 2) + b;
    }
  });
})(jQuery, window, document);

/*
 * # Semantic - Modal
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Copyright 2014 Contributor
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */

(function ($, window, document, undefined) {
  $.fn.modal = function (parameters) {
    const $allModules = $(this);
    const $window = $(window);
    const $document = $(document);
    const $body = $('body');
    const moduleSelector = $allModules.selector || '';
    let time = new Date().getTime();
    let performance = [];
    const query = arguments[0];
    const methodInvoked = typeof query === 'string';
    const queryArguments = [].slice.call(arguments, 1);
    const requestAnimationFrame =
      window.requestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      window.msRequestAnimationFrame ||
      function (callback) {
        setTimeout(callback, 0);
      };
    let returnedValue;

    $allModules.each(function () {
      const settings = $.isPlainObject(parameters)
        ? $.extend(true, {}, $.fn.modal.settings, parameters)
        : $.extend({}, $.fn.modal.settings);
      const { selector } = settings;
      const { className } = settings;
      const { namespace } = settings;
      const { error } = settings;
      const eventNamespace = `.${namespace}`;
      const moduleNamespace = `module-${namespace}`;
      const $module = $(this);
      const $context = $(settings.context);
      const $close = $module.find(selector.close);
      let $allModals;
      let $otherModals;
      let $focusedElement;
      let $dimmable;
      let $dimmer;
      const element = this;
      let instance = $module.data(moduleNamespace);
      let elementNamespace;
      let id;
      let observer;
      let module;
      module = {
        initialize() {
          module.verbose('Initializing dimmer', $context);

          if ($.fn.dimmer === undefined) {
            module.error(error.dimmer);
            return;
          }

          id = module.get.uniqueID();
          elementNamespace = `.${id}`;

          $dimmable = $context.dimmer({
            debug: settings.debug,
            dimmerName: 'modals',
            closable: false,
            useCSS: true,
            duration: {
              show: settings.duration * 0.9,
              hide: settings.duration * 1.1
            }
          });
          if (settings.detachable) {
            $dimmable.dimmer('add content', $module);
          }

          $dimmer = $dimmable.dimmer('get dimmer');
          module.refreshModals();

          module.verbose('Attaching close events', $close);
          module.bind.events();
          module.observeChanges();

          module.instantiate();
        },

        instantiate() {
          module.verbose('Storing instance of modal');
          instance = module;
          $module.data(moduleNamespace, instance);
        },

        destroy() {
          module.verbose('Destroying previous modal');
          $module.removeData(moduleNamespace).off(eventNamespace);
          $window.off(elementNamespace);
          $close.off(eventNamespace);
          $context.dimmer('destroy');
        },

        observeChanges() {
          if ('MutationObserver' in window) {
            observer = new MutationObserver(function (mutations) {
              module.debug('DOM tree modified, refreshing');
              module.refresh();
            });
            observer.observe(element, {
              childList: true,
              subtree: true
            });
            module.debug('Setting up mutation observer', observer);
          }
        },

        refresh() {
          module.remove.scrolling();
          module.cacheSizes();
          module.set.screenHeight();
          module.set.type();
          module.set.position();
        },

        refreshModals() {
          $otherModals = $module.siblings(selector.modal);
          $allModals = $otherModals.add($module);
        },

        attachEvents(selector, event) {
          const $toggle = $(selector);
          event = $.isFunction(module[event]) ? module[event] : module.toggle;
          if ($toggle.size() > 0) {
            module.debug('Attaching modal events to element', selector, event);
            $toggle.off(eventNamespace).on(`click${eventNamespace}`, event);
          } else {
            module.error(error.notFound, selector);
          }
        },

        bind: {
          events() {
            $close.on(`click${eventNamespace}`, module.event.close);
            $window.on(`resize${elementNamespace}`, module.event.resize);
          }
        },

        get: {
          uniqueID() {
            return `${Math.random().toString(16)}000000000`.substr(2, 8);
          }
        },

        event: {
          close() {
            module.verbose('Closing element pressed');
            if ($(this).is(selector.approve)) {
              if ($.proxy(settings.onApprove, element)() !== false) {
                module.hide();
              } else {
                module.verbose(
                  'Approve callback returned false cancelling hide'
                );
              }
            } else if ($(this).is(selector.deny)) {
              if ($.proxy(settings.onDeny, element)() !== false) {
                module.hide();
              } else {
                module.verbose('Deny callback returned false cancelling hide');
              }
            } else {
              module.hide();
            }
          },
          click(event) {
            if ($(event.target).closest($module).size() === 0) {
              module.debug('Dimmer clicked, hiding all modals');
              if (module.is.active()) {
                module.remove.clickaway();
                if (settings.allowMultiple) {
                  module.hide();
                } else {
                  module.hideAll();
                }
              }
            }
          },
          debounce(method, delay) {
            clearTimeout(module.timer);
            module.timer = setTimeout(method, delay);
          },
          keyboard(event) {
            const keyCode = event.which;
            const escapeKey = 27;
            if (keyCode == escapeKey) {
              if (settings.closable) {
                module.debug('Escape key pressed hiding modal');
                module.hide();
              } else {
                module.debug(
                  'Escape key pressed, but closable is set to false'
                );
              }
              event.preventDefault();
            }
          },
          resize() {
            if ($dimmable.dimmer('is active')) {
              requestAnimationFrame(module.refresh);
            }
          }
        },

        toggle() {
          if (module.is.active() || module.is.animating()) {
            module.hide();
          } else {
            module.show();
          }
        },

        show(callback) {
          callback = $.isFunction(callback) ? callback : function () {};
          module.refreshModals();
          module.showDimmer();
          module.showModal(callback);
        },

        hide(callback) {
          callback = $.isFunction(callback) ? callback : function () {};
          module.refreshModals();
          if (!module.othersActive()) {
            module.hideDimmer();
          }
          module.hideModal(callback);
        },

        showModal(callback) {
          callback = $.isFunction(callback) ? callback : function () {};
          if (!module.is.active()) {
            if (
              !settings.allowMultiple &&
              $otherModals.filter(':visible').size() > 0
            ) {
              module.debug('Other modals visible, queueing show animation');
              module.hideOthers(module.showModal);
            } else {
              $.proxy(settings.onShow, element)();
              if (
                settings.transition &&
                $.fn.transition !== undefined &&
                $module.transition('is supported')
              ) {
                module.debug('Showing modal with css animations');
                module.cacheSizes();
                module.set.position();
                module.set.screenHeight();
                module.set.type();
                module.set.clickaway();
                $module.transition({
                  debug: settings.debug,
                  animation: `${settings.transition} in`,
                  queue: false,
                  duration: settings.duration,
                  onComplete() {
                    $.proxy(settings.onVisible, element)();
                    module.add.keyboardShortcuts();
                    module.save.focus();
                    module.set.active();
                    module.set.autofocus();
                    callback();
                  }
                });
              } else {
                module.debug('Showing modal with javascript');
                $module.fadeIn(settings.duration, settings.easing, function () {
                  $.proxy(settings.onVisible, element)();
                  module.add.keyboardShortcuts();
                  module.save.focus();
                  module.set.active();
                  callback();
                });
              }
            }
          } else {
            module.debug('Modal is already visible');
          }
        },

        showDimmer() {
          if (!$dimmable.dimmer('is active')) {
            module.debug('Showing dimmer');
            $dimmable.dimmer('show');
          } else {
            module.debug('Dimmer already visible');
          }
        },

        hideDimmer() {
          if (
            !($dimmable.dimmer('is active') || $dimmable.dimmer('is animating'))
          ) {
            module.debug('Dimmer is not visible cannot hide');
            return;
          }
          module.debug('Hiding dimmer');
          $dimmable.dimmer('hide', function () {
            if (
              settings.transition &&
              $.fn.transition !== undefined &&
              $module.transition('is supported')
            ) {
              module.remove.clickaway();
              module.remove.screenHeight();
            }
          });
        },

        hideModal(callback) {
          callback = $.isFunction(callback) ? callback : function () {};
          module.debug('Hiding modal');
          $.proxy(settings.onHide, element)();
          if (
            settings.transition &&
            $.fn.transition !== undefined &&
            $module.transition('is supported')
          ) {
            module.remove.active();
            $module.transition({
              debug: settings.debug,
              animation: `${settings.transition} out`,
              queue: false,
              duration: settings.duration,
              onStart() {
                module.remove.keyboardShortcuts();
              },
              onComplete() {
                $.proxy(settings.onHidden, element)();
                module.restore.focus();
                callback();
              }
            });
          } else {
            module.remove.active();
            module.remove.keyboardShortcuts();
            $module.fadeOut(settings.duration, settings.easing, function () {
              $.proxy(settings.onHidden, element)();
              module.restore.focus();
              callback();
            });
          }
        },

        hideAll(callback) {
          callback = $.isFunction(callback) ? callback : function () {};
          if ($allModals.is(':visible')) {
            module.debug('Hiding all visible modals');
            module.hideDimmer();
            $allModals.filter(':visible').modal('hide modal', callback);
          }
        },

        hideOthers(callback) {
          callback = $.isFunction(callback) ? callback : function () {};
          if ($otherModals.is(':visible')) {
            module.debug('Hiding other modals', $otherModals);
            $otherModals.filter(':visible').modal('hide modal', callback);
          }
        },

        othersActive() {
          return $otherModals.filter(`.${className.active}`).size() > 0;
        },

        add: {
          keyboardShortcuts() {
            module.verbose('Adding keyboard shortcuts');
            $document.on(`keyup${eventNamespace}`, module.event.keyboard);
          }
        },

        save: {
          focus() {
            $focusedElement = $(document.activeElement).blur();
          }
        },

        restore: {
          focus() {
            if ($focusedElement && $focusedElement.size() > 0) {
              $focusedElement.focus();
            }
          }
        },

        remove: {
          active() {
            $module.removeClass(className.active);
          },
          clickaway() {
            if (settings.closable) {
              $dimmer.off(`click${elementNamespace}`);
            }
          },
          screenHeight() {
            if (module.cache.height > module.cache.pageHeight) {
              module.debug('Removing page height');
              $body.css('height', '');
            }
          },
          keyboardShortcuts() {
            module.verbose('Removing keyboard shortcuts');
            $document.off(`keyup${eventNamespace}`);
          },
          scrolling() {
            $dimmable.removeClass(className.scrolling);
            $module.removeClass(className.scrolling);
          }
        },

        cacheSizes() {
          const modalHeight = $module.outerHeight();
          if (module.cache === undefined || modalHeight !== 0) {
            module.cache = {
              pageHeight: $(document).outerHeight(),
              height: modalHeight + settings.offset,
              contextHeight:
                settings.context == 'body'
                  ? $(window).height()
                  : $dimmable.height()
            };
          }
          module.debug('Caching modal and container sizes', module.cache);
        },

        can: {
          fit() {
            return module.cache.height < module.cache.contextHeight;
          }
        },

        is: {
          active() {
            return $module.hasClass(className.active);
          },
          animating() {
            return $module.transition('is supported')
              ? $module.transition('is animating')
              : $module.is(':visible');
          },
          scrolling() {
            return $dimmable.hasClass(className.scrolling);
          },
          modernBrowser() {
            // appName for IE11 reports 'Netscape' can no longer use
            return !(window.ActiveXObject || 'ActiveXObject' in window);
          }
        },

        set: {
          autofocus() {
            if (settings.autofocus) {
              const $inputs = $module.find(':input:visible');
              const $autofocus = $inputs.filter('[autofocus]');
              const $input = $autofocus.size() > 0 ? $autofocus : $inputs;
              $input.first().focus();
            }
          },
          clickaway() {
            if (settings.closable) {
              $dimmer.on(`click${elementNamespace}`, module.event.click);
            }
          },
          screenHeight() {
            if (module.cache.height > module.cache.pageHeight) {
              module.debug(
                'Modal is taller than page content, resizing page height'
              );
              $body.css('height', module.cache.height + settings.padding);
            } else {
              $body.css('height', '');
            }
          },
          active() {
            $module.addClass(className.active);
          },
          scrolling() {
            $dimmable.addClass(className.scrolling);
            $module.addClass(className.scrolling);
          },
          type() {
            if (module.can.fit()) {
              module.verbose('Modal fits on screen');
              if (!module.othersActive) {
                module.remove.scrolling();
              }
            } else {
              module.verbose('Modal cannot fit on screen setting to scrolling');
              module.set.scrolling();
            }
          },
          position() {
            module.verbose('Centering modal on page', module.cache);
            if (module.can.fit()) {
              $module.css({
                top: '',
                marginTop: -(module.cache.height / 2)
              });
            } else {
              $module.css({
                marginTop: '',
                top: $document.scrollTop()
              });
            }
          }
        },

        setting(name, value) {
          module.debug('Changing setting', name, value);
          if ($.isPlainObject(name)) {
            $.extend(true, settings, name);
          } else if (value !== undefined) {
            settings[name] = value;
          } else {
            return settings[name];
          }
        },
        internal(name, value) {
          if ($.isPlainObject(name)) {
            $.extend(true, module, name);
          } else if (value !== undefined) {
            module[name] = value;
          } else {
            return module[name];
          }
        },
        debug() {
          if (settings.debug) {
            if (settings.performance) {
              module.performance.log(arguments);
            } else {
              module.debug = Function.prototype.bind.call(
                console.info,
                console,
                `${settings.name}:`
              );
              module.debug.apply(console, arguments);
            }
          }
        },
        verbose() {
          if (settings.verbose && settings.debug) {
            if (settings.performance) {
              module.performance.log(arguments);
            } else {
              module.verbose = Function.prototype.bind.call(
                console.info,
                console,
                `${settings.name}:`
              );
              module.verbose.apply(console, arguments);
            }
          }
        },
        error() {
          module.error = Function.prototype.bind.call(
            console.error,
            console,
            `${settings.name}:`
          );
          module.error.apply(console, arguments);
        },
        performance: {
          log(message) {
            let currentTime;
            let executionTime;
            let previousTime;
            if (settings.performance) {
              currentTime = new Date().getTime();
              previousTime = time || currentTime;
              executionTime = currentTime - previousTime;
              time = currentTime;
              performance.push({
                Name: message[0],
                Arguments: [].slice.call(message, 1) || '',
                Element: element,
                'Execution Time': executionTime
              });
            }
            clearTimeout(module.performance.timer);
            module.performance.timer = setTimeout(
              module.performance.display,
              100
            );
          },
          display() {
            let title = `${settings.name}:`;
            let totalTime = 0;
            time = false;
            clearTimeout(module.performance.timer);
            $.each(performance, function (index, data) {
              totalTime += data['Execution Time'];
            });
            title += ` ${totalTime}ms`;
            if (moduleSelector) {
              title += ` '${moduleSelector}'`;
            }
            if (
              (console.group !== undefined || console.table !== undefined) &&
              performance.length > 0
            ) {
              console.groupCollapsed(title);
              if (console.table) {
                console.table(performance);
              } else {
                $.each(performance, function (index, data) {
                  console.log(`${data.Name}: ${data['Execution Time']}ms`);
                });
              }
              console.groupEnd();
            }
            performance = [];
          }
        },
        invoke(query, passedArguments, context) {
          let object = instance;
          let maxDepth;
          let found;
          let response;
          passedArguments = passedArguments || queryArguments;
          context = element || context;
          if (typeof query === 'string' && object !== undefined) {
            query = query.split(/[\. ]/);
            maxDepth = query.length - 1;
            $.each(query, function (depth, value) {
              const camelCaseValue =
                depth != maxDepth
                  ? value +
                    query[depth + 1].charAt(0).toUpperCase() +
                    query[depth + 1].slice(1)
                  : query;
              if (
                $.isPlainObject(object[camelCaseValue]) &&
                depth != maxDepth
              ) {
                object = object[camelCaseValue];
              } else if (object[camelCaseValue] !== undefined) {
                found = object[camelCaseValue];
                return false;
              } else if ($.isPlainObject(object[value]) && depth != maxDepth) {
                object = object[value];
              } else if (object[value] !== undefined) {
                found = object[value];
                return false;
              } else {
                return false;
              }
            });
          }
          if ($.isFunction(found)) {
            response = found.apply(context, passedArguments);
          } else if (found !== undefined) {
            response = found;
          }
          if ($.isArray(returnedValue)) {
            returnedValue.push(response);
          } else if (returnedValue !== undefined) {
            returnedValue = [returnedValue, response];
          } else if (response !== undefined) {
            returnedValue = response;
          }
          return found;
        }
      };

      if (methodInvoked) {
        if (instance === undefined) {
          module.initialize();
        }
        module.invoke(query);
      } else {
        if (instance !== undefined) {
          module.destroy();
        }
        module.initialize();
      }
    });

    return returnedValue !== undefined ? returnedValue : this;
  };

  $.fn.modal.settings = {
    name: 'Modal',
    namespace: 'modal',

    debug: false,
    verbose: true,
    performance: true,

    allowMultiple: false,
    detachable: true,
    closable: true,
    autofocus: true,

    context: 'body',

    duration: 500,
    easing: 'easeOutExpo',
    offset: 0,
    transition: 'scale',

    padding: 30,

    onShow() {},
    onHide() {},

    onVisible() {},
    onHidden() {},

    onApprove() {
      return true;
    },
    onDeny() {
      return true;
    },

    selector: {
      close: '.close, .actions .button',
      approve: '.actions .positive, .actions .approve, .actions .ok',
      deny: '.actions .negative, .actions .deny, .actions .cancel',
      modal: '.ui.modal'
    },
    error: {
      dimmer: 'UI Dimmer, a required component is not included in this page',
      method: 'The method you called is not defined.',
      notFound: 'The element you specified could not be found'
    },
    className: {
      active: 'active',
      scrolling: 'scrolling'
    }
  };
})(jQuery, window, document);

/*
 * # Semantic - Sidebar
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Copyright 2014 Contributor
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */

(function ($, window, document, undefined) {
  $.fn.sidebar = function (parameters) {
    const $allModules = $(this);
    const $window = $(window);
    const $document = $(document);
    const $head = $('head');
    const moduleSelector = $allModules.selector || '';
    let time = new Date().getTime();
    let performance = [];
    const query = arguments[0];
    const methodInvoked = typeof query === 'string';
    const queryArguments = [].slice.call(arguments, 1);
    const requestAnimationFrame =
      window.requestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      window.msRequestAnimationFrame ||
      function (callback) {
        setTimeout(callback, 0);
      };
    let returnedValue;

    $allModules.each(function () {
      const settings = $.isPlainObject(parameters)
        ? $.extend(true, {}, $.fn.sidebar.settings, parameters)
        : $.extend({}, $.fn.sidebar.settings);
      const { selector } = settings;
      const { className } = settings;
      const { namespace } = settings;
      const { error } = settings;
      const eventNamespace = `.${namespace}`;
      const moduleNamespace = `module-${namespace}`;
      const $module = $(this);
      let $context = $(settings.context);
      let $sidebars = $module.children(selector.sidebar);
      let $pusher = $context.children(selector.pusher);
      let $style;
      const element = this;
      let instance = $module.data(moduleNamespace);
      let elementNamespace;
      let id;
      let currentScroll;
      let transitionEvent;
      let module;

      module = {
        initialize() {
          module.debug('Initializing sidebar', parameters);

          transitionEvent = module.get.transitionEvent();

          // cache on initialize
          if (module.is.legacy() || settings.legacy) {
            settings.transition = 'overlay';
            settings.useLegacy = true;
          }

          id = module.get.uniqueID();
          elementNamespace = `.${id}`;

          // avoids locking rendering if initialized in onReady
          requestAnimationFrame(module.setup.layout);

          module.instantiate();
        },

        instantiate() {
          module.verbose('Storing instance of module', module);
          instance = module;
          $module.data(moduleNamespace, module);
        },

        destroy() {
          module.verbose('Destroying previous module for', $module);
          module.remove.direction();
          $module.off(eventNamespace).removeData(moduleNamespace);
          // bound by uuid
          $context.off(elementNamespace);
          $window.off(elementNamespace);
          $document.off(elementNamespace);
        },

        event: {
          clickaway(event) {
            if ($(event.target).closest(selector.sidebar).size() === 0) {
              module.verbose('User clicked on dimmed page');
              module.hide();
            }
          },
          touch(event) {
            // event.stopPropagation();
          },
          containScroll(event) {
            if (element.scrollTop <= 0) {
              element.scrollTop = 1;
            }
            if (
              element.scrollTop + element.offsetHeight >=
              element.scrollHeight
            ) {
              element.scrollTop =
                element.scrollHeight - element.offsetHeight - 1;
            }
          },
          scroll(event) {
            if ($(event.target).closest(selector.sidebar).size() === 0) {
              event.preventDefault();
            }
          }
        },

        bind: {
          clickaway() {
            module.verbose('Adding clickaway events to context', $context);
            if (settings.closable) {
              $context
                .on(`click${elementNamespace}`, module.event.clickaway)
                .on(`touchend${elementNamespace}`, module.event.clickaway);
            }
          },
          scrollLock() {
            if (settings.scrollLock) {
              module.debug('Disabling page scroll');
              $window.on(
                `DOMMouseScroll${elementNamespace}`,
                module.event.scroll
              );
            }
            module.verbose('Adding events to contain sidebar scroll');
            $document.on(`touchmove${elementNamespace}`, module.event.touch);
            $module.on(`scroll${eventNamespace}`, module.event.containScroll);
          }
        },
        unbind: {
          clickaway() {
            module.verbose('Removing clickaway events from context', $context);
            $context.off(elementNamespace);
          },
          scrollLock() {
            module.verbose('Removing scroll lock from page');
            $document.off(elementNamespace);
            $window.off(elementNamespace);
            $module.off(`scroll${eventNamespace}`);
          }
        },

        add: {
          bodyCSS(direction, distance) {
            const width = $module.outerWidth();
            const height = $module.outerHeight();
            let style;
            style =
              `${'' + '<style title="'}${namespace}">` +
              ` .ui.visible.left.sidebar ~ .fixed,` +
              ` .ui.visible.left.sidebar ~ .pusher {` +
              `   -webkit-transform: translate3d(${width}px, 0, 0);` +
              `           transform: translate3d(${width}px, 0, 0);` +
              ` }` +
              ` .ui.visible.right.sidebar ~ .fixed,` +
              ` .ui.visible.right.sidebar ~ .pusher {` +
              `   -webkit-transform: translate3d(-${width}px, 0, 0);` +
              `           transform: translate3d(-${width}px, 0, 0);` +
              ` }` +
              ` .ui.visible.left.sidebar ~ .ui.visible.right.sidebar ~ .fixed,` +
              ` .ui.visible.left.sidebar ~ .ui.visible.right.sidebar ~ .pusher,` +
              ` .ui.visible.right.sidebar ~ .ui.visible.left.sidebar ~ .fixed,` +
              ` .ui.visible.right.sidebar ~ .ui.visible.left.sidebar ~ .pusher {` +
              `   -webkit-transform: translate3d(0px, 0, 0);` +
              `           transform: translate3d(0px, 0, 0);` +
              ` }` +
              ` .ui.visible.top.sidebar ~ .fixed,` +
              ` .ui.visible.top.sidebar ~ .pusher {` +
              `   -webkit-transform: translate3d(0, ${height}px, 0);` +
              `           transform: translate3d(0, ${height}px, 0);` +
              ` }` +
              ` .ui.visible.bottom.sidebar ~ .fixed,` +
              ` .ui.visible.bottom.sidebar ~ .pusher {` +
              `   -webkit-transform: translate3d(0, -${height}px, 0);` +
              `           transform: translate3d(0, -${height}px, 0);` +
              ` }`;

            /* IE is only browser not to create context with transforms */
            /* https://www.w3.org/Bugs/Public/show_bug.cgi?id=16328 */
            if (module.is.ie()) {
              style +=
                `${
                  '' +
                  ' .ui.visible.left.sidebar ~ .pusher:after {' +
                  '   -webkit-transform: translate3d('
                }${width}px, 0, 0);` +
                `           transform: translate3d(${width}px, 0, 0);` +
                ` }` +
                ` .ui.visible.right.sidebar ~ .pusher:after {` +
                `   -webkit-transform: translate3d(-${width}px, 0, 0);` +
                `           transform: translate3d(-${width}px, 0, 0);` +
                ` }` +
                ` .ui.visible.left.sidebar ~ .ui.visible.right.sidebar ~ .pusher:after,` +
                ` .ui.visible.right.sidebar ~ .ui.visible.left.sidebar ~ .pusher:after {` +
                `   -webkit-transform: translate3d(0px, 0, 0);` +
                `           transform: translate3d(0px, 0, 0);` +
                ` }` +
                ` .ui.visible.top.sidebar ~ .pusher:after {` +
                `   -webkit-transform: translate3d(0, ${height}px, 0);` +
                `           transform: translate3d(0, ${height}px, 0);` +
                ` }` +
                ` .ui.visible.bottom.sidebar ~ .pusher:after {` +
                `   -webkit-transform: translate3d(0, -${height}px, 0);` +
                `           transform: translate3d(0, -${height}px, 0);` +
                ` }`;
            }

            style += '</style>';

            $head.append(style);
            $style = $(`style[title=${namespace}]`);
            module.debug('Adding sizing css to head', $style);
          }
        },

        refresh() {
          module.verbose('Refreshing selector cache');
          $context = $(settings.context);
          $sidebars = $context.children(selector.sidebar);
          $pusher = $context.children(selector.pusher);
        },

        refreshSidebars() {
          module.verbose('Refreshing other sidebars');
          $sidebars = $context.children(selector.sidebar);
        },

        repaint() {
          module.verbose('Forcing repaint event');
          element.style.display = 'none';
          element.offsetHeight;
          element.scrollTop = element.scrollTop;
          element.style.display = '';
        },

        setup: {
          layout() {
            if ($context.children(selector.pusher).size() === 0) {
              module.debug('Adding wrapper element for sidebar');
              module.error(error.pusher);
              $pusher = $('<div class="pusher" />');
              $context
                .children()
                .not(selector.omitted)
                .not($sidebars)
                .wrapAll($pusher);
              module.refresh();
            }
            if (
              $module.nextAll(selector.pusher).size() === 0 ||
              $module.nextAll(selector.pusher)[0] !== $pusher[0]
            ) {
              module.debug('Moved sidebar to correct parent element');
              module.error(error.movedSidebar, element);
              $module.detach().prependTo($context);
              module.refresh();
            }
            module.set.pushable();
            module.set.direction();
          }
        },

        attachEvents(selector, event) {
          const $toggle = $(selector);
          event = $.isFunction(module[event]) ? module[event] : module.toggle;
          if ($toggle.size() > 0) {
            module.debug(
              'Attaching sidebar events to element',
              selector,
              event
            );
            $toggle.on(`click${eventNamespace}`, event);
          } else {
            module.error(error.notFound, selector);
          }
        },

        show(callback) {
          const animateMethod = settings.useLegacy
            ? module.legacyPushPage
            : module.pushPage;
          callback = $.isFunction(callback) ? callback : function () {};
          if (module.is.hidden()) {
            module.refreshSidebars();
            if (settings.overlay) {
              module.error(error.overlay);
              settings.transition = 'overlay';
            }
            module.refresh();
            if (
              module.othersVisible() &&
              module.get.transition() != 'overlay'
            ) {
              module.debug('Other sidebars currently open');
              if (settings.exclusive) {
                module.hideOthers();
              }
            }
            animateMethod(function () {
              $.proxy(callback, element)();
              $.proxy(settings.onShow, element)();
            });
            $.proxy(settings.onChange, element)();
            $.proxy(settings.onVisible, element)();
          } else {
            module.debug('Sidebar is already visible');
          }
        },

        hide(callback) {
          const animateMethod = settings.useLegacy
            ? module.legacyPullPage
            : module.pullPage;
          callback = $.isFunction(callback) ? callback : function () {};
          if (module.is.visible() || module.is.animating()) {
            module.debug('Hiding sidebar', callback);
            module.refreshSidebars();
            animateMethod(function () {
              $.proxy(callback, element)();
              $.proxy(settings.onHidden, element)();
            });
            $.proxy(settings.onChange, element)();
            $.proxy(settings.onHide, element)();
          }
        },

        othersVisible() {
          return (
            $sidebars.not($module).filter(`.${className.visible}`).size() > 0
          );
        },

        hideOthers(callback) {
          const $otherSidebars = $sidebars
            .not($module)
            .filter(`.${className.visible}`);
          var callback = callback || function () {};
          const sidebarCount = $otherSidebars.size();
          let callbackCount = 0;
          $otherSidebars.sidebar('hide', function () {
            callbackCount++;
            if (callbackCount == sidebarCount) {
              callback();
            }
          });
        },

        toggle() {
          module.verbose('Determining toggled direction');
          if (module.is.hidden()) {
            module.show();
          } else {
            module.hide();
          }
        },

        pushPage(callback) {
          const transition = module.get.transition();
          const $transition =
            transition == 'safe'
              ? $context
              : transition == 'overlay' || module.othersVisible()
              ? $module
              : $pusher;
          let animate;
          let transitionEnd;
          callback = $.isFunction(callback) ? callback : function () {};
          if (
            settings.transition == 'scale down' ||
            (module.is.mobile() && transition !== 'overlay')
          ) {
            module.scrollToTop();
          }
          module.set.transition();
          module.repaint();
          animate = function () {
            module.bind.clickaway();
            module.add.bodyCSS();
            module.set.animating();
            module.set.visible();
            if (!module.othersVisible()) {
              if (settings.dimPage) {
                $pusher.addClass(className.dimmed);
              }
            }
          };
          transitionEnd = function (event) {
            if (event.target == $transition[0]) {
              $transition.off(
                transitionEvent + elementNamespace,
                transitionEnd
              );
              module.remove.animating();
              module.bind.scrollLock();
              $.proxy(callback, element)();
            }
          };
          $transition.off(transitionEvent + elementNamespace);
          $transition.on(transitionEvent + elementNamespace, transitionEnd);
          requestAnimationFrame(animate);
        },

        pullPage(callback) {
          const transition = module.get.transition();
          const $transition =
            transition == 'safe'
              ? $context
              : transition == 'overlay' || module.othersVisible()
              ? $module
              : $pusher;
          let animate;
          let transitionEnd;
          callback = $.isFunction(callback) ? callback : function () {};
          module.verbose('Removing context push state', module.get.direction());

          module.unbind.clickaway();
          module.unbind.scrollLock();

          animate = function () {
            module.set.animating();
            module.remove.visible();
            if (settings.dimPage && !module.othersVisible()) {
              $pusher.removeClass(className.dimmed);
            }
          };
          transitionEnd = function (event) {
            if (event.target == $transition[0]) {
              $transition.off(
                transitionEvent + elementNamespace,
                transitionEnd
              );
              module.remove.animating();
              module.remove.transition();
              module.remove.bodyCSS();
              if (
                transition == 'scale down' ||
                (settings.returnScroll && module.is.mobile())
              ) {
                module.scrollBack();
              }
              $.proxy(callback, element)();
            }
          };
          $transition.off(transitionEvent + elementNamespace);
          $transition.on(transitionEvent + elementNamespace, transitionEnd);
          requestAnimationFrame(animate);
        },

        legacyPushPage(callback) {
          let distance = $module.width();
          const direction = module.get.direction();
          const properties = {};
          distance = distance || $module.width();
          callback = $.isFunction(callback) ? callback : function () {};
          properties[direction] = distance;
          module.debug('Using javascript to push context', properties);
          module.set.visible();
          module.set.transition();
          module.set.animating();
          if (settings.dimPage) {
            $pusher.addClass(className.dimmed);
          }
          $context
            .css('position', 'relative')
            .animate(
              properties,
              settings.duration,
              settings.easing,
              function () {
                module.remove.animating();
                module.bind.clickaway();
                $.proxy(callback, module)();
              }
            );
        },
        legacyPullPage(callback) {
          let distance = 0;
          const direction = module.get.direction();
          const properties = {};
          distance = distance || $module.width();
          callback = $.isFunction(callback) ? callback : function () {};
          properties[direction] = '0px';
          module.debug('Using javascript to pull context', properties);
          module.unbind.clickaway();
          module.set.animating();
          module.remove.visible();
          if (settings.dimPage && !module.othersVisible()) {
            $pusher.removeClass(className.dimmed);
          }
          $context
            .css('position', 'relative')
            .animate(
              properties,
              settings.duration,
              settings.easing,
              function () {
                module.remove.animating();
                $.proxy(callback, module)();
              }
            );
        },

        scrollToTop() {
          module.verbose('Scrolling to top of page to avoid animation issues');
          currentScroll = $(window).scrollTop();
          $module.scrollTop(0);
          window.scrollTo(0, 0);
        },

        scrollBack() {
          module.verbose('Scrolling back to original page position');
          window.scrollTo(0, currentScroll);
        },

        set: {
          // container
          pushed() {
            $context.addClass(className.pushed);
          },
          pushable() {
            $context.addClass(className.pushable);
          },

          // sidebar
          active() {
            $module.addClass(className.active);
          },
          animating() {
            $module.addClass(className.animating);
          },
          transition(transition) {
            transition = transition || module.get.transition();
            $module.addClass(transition);
          },
          direction(direction) {
            direction = direction || module.get.direction();
            $module.addClass(className[direction]);
          },
          visible() {
            $module.addClass(className.visible);
          },
          overlay() {
            $module.addClass(className.overlay);
          }
        },
        remove: {
          bodyCSS() {
            module.debug('Removing body css styles', $style);
            if ($style.size() > 0) {
              $style.remove();
            }
          },

          // context
          pushed() {
            $context.removeClass(className.pushed);
          },
          pushable() {
            $context.removeClass(className.pushable);
          },

          // sidebar
          active() {
            $module.removeClass(className.active);
          },
          animating() {
            $module.removeClass(className.animating);
          },
          transition(transition) {
            transition = transition || module.get.transition();
            $module.removeClass(transition);
          },
          direction(direction) {
            direction = direction || module.get.direction();
            $module.removeClass(className[direction]);
          },
          visible() {
            $module.removeClass(className.visible);
          },
          overlay() {
            $module.removeClass(className.overlay);
          }
        },

        get: {
          direction() {
            if ($module.hasClass(className.top)) {
              return className.top;
            }
            if ($module.hasClass(className.right)) {
              return className.right;
            }
            if ($module.hasClass(className.bottom)) {
              return className.bottom;
            }
            return className.left;
          },
          transition() {
            const direction = module.get.direction();
            let transition;
            return module.is.mobile()
              ? settings.mobileTransition == 'auto'
                ? settings.defaultTransition.mobile[direction]
                : settings.mobileTransition
              : settings.transition == 'auto'
              ? settings.defaultTransition.computer[direction]
              : settings.transition;
          },
          transitionEvent() {
            const element = document.createElement('element');
            const transitions = {
              transition: 'transitionend',
              OTransition: 'oTransitionEnd',
              MozTransition: 'transitionend',
              WebkitTransition: 'webkitTransitionEnd'
            };
            let transition;
            for (transition in transitions) {
              if (element.style[transition] !== undefined) {
                return transitions[transition];
              }
            }
          },
          uniqueID() {
            return `${Math.random().toString(16)}000000000`.substr(2, 8);
          }
        },

        is: {
          ie() {
            const isIE11 = !window.ActiveXObject && 'ActiveXObject' in window;
            const isIE = 'ActiveXObject' in window;
            return isIE11 || isIE;
          },

          legacy() {
            const element = document.createElement('div');
            const transforms = {
              webkitTransform: '-webkit-transform',
              OTransform: '-o-transform',
              msTransform: '-ms-transform',
              MozTransform: '-moz-transform',
              transform: 'transform'
            };
            let has3D;

            // Add it to the body to get the computed style.
            document.body.insertBefore(element, null);
            for (const transform in transforms) {
              if (element.style[transform] !== undefined) {
                element.style[transform] = 'translate3d(1px,1px,1px)';
                has3D = window
                  .getComputedStyle(element)
                  .getPropertyValue(transforms[transform]);
              }
            }
            document.body.removeChild(element);
            return !(
              has3D !== undefined &&
              has3D.length > 0 &&
              has3D !== 'none'
            );
          },
          mobile() {
            const { userAgent } = navigator;
            const mobileRegExp = /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/;
            const isMobile = mobileRegExp.test(userAgent);
            if (isMobile) {
              module.verbose('Browser was found to be mobile', userAgent);
              return true;
            }
            module.verbose(
              'Browser is not mobile, using regular transition',
              userAgent
            );
            return false;
          },
          hidden() {
            return !module.is.visible();
          },
          visible() {
            return $module.hasClass(className.visible);
          },
          // alias
          open() {
            return module.is.visible();
          },
          closed() {
            return module.is.hidden();
          },
          vertical() {
            return $module.hasClass(className.top);
          },
          animating() {
            return $context.hasClass(className.animating);
          }
        },

        setting(name, value) {
          module.debug('Changing setting', name, value);
          if ($.isPlainObject(name)) {
            $.extend(true, settings, name);
          } else if (value !== undefined) {
            settings[name] = value;
          } else {
            return settings[name];
          }
        },
        internal(name, value) {
          if ($.isPlainObject(name)) {
            $.extend(true, module, name);
          } else if (value !== undefined) {
            module[name] = value;
          } else {
            return module[name];
          }
        },
        debug() {
          if (settings.debug) {
            if (settings.performance) {
              module.performance.log(arguments);
            } else {
              module.debug = Function.prototype.bind.call(
                console.info,
                console,
                `${settings.name}:`
              );
              module.debug.apply(console, arguments);
            }
          }
        },
        verbose() {
          if (settings.verbose && settings.debug) {
            if (settings.performance) {
              module.performance.log(arguments);
            } else {
              module.verbose = Function.prototype.bind.call(
                console.info,
                console,
                `${settings.name}:`
              );
              module.verbose.apply(console, arguments);
            }
          }
        },
        error() {
          module.error = Function.prototype.bind.call(
            console.error,
            console,
            `${settings.name}:`
          );
          module.error.apply(console, arguments);
        },
        performance: {
          log(message) {
            let currentTime;
            let executionTime;
            let previousTime;
            if (settings.performance) {
              currentTime = new Date().getTime();
              previousTime = time || currentTime;
              executionTime = currentTime - previousTime;
              time = currentTime;
              performance.push({
                Name: message[0],
                Arguments: [].slice.call(message, 1) || '',
                Element: element,
                'Execution Time': executionTime
              });
            }
            clearTimeout(module.performance.timer);
            module.performance.timer = setTimeout(
              module.performance.display,
              100
            );
          },
          display() {
            let title = `${settings.name}:`;
            let totalTime = 0;
            time = false;
            clearTimeout(module.performance.timer);
            $.each(performance, function (index, data) {
              totalTime += data['Execution Time'];
            });
            title += ` ${totalTime}ms`;
            if (moduleSelector) {
              title += ` '${moduleSelector}'`;
            }
            if (
              (console.group !== undefined || console.table !== undefined) &&
              performance.length > 0
            ) {
              console.groupCollapsed(title);
              if (console.table) {
                console.table(performance);
              } else {
                $.each(performance, function (index, data) {
                  console.log(`${data.Name}: ${data['Execution Time']}ms`);
                });
              }
              console.groupEnd();
            }
            performance = [];
          }
        },
        invoke(query, passedArguments, context) {
          let object = instance;
          let maxDepth;
          let found;
          let response;
          passedArguments = passedArguments || queryArguments;
          context = element || context;
          if (typeof query === 'string' && object !== undefined) {
            query = query.split(/[\. ]/);
            maxDepth = query.length - 1;
            $.each(query, function (depth, value) {
              const camelCaseValue =
                depth != maxDepth
                  ? value +
                    query[depth + 1].charAt(0).toUpperCase() +
                    query[depth + 1].slice(1)
                  : query;
              if (
                $.isPlainObject(object[camelCaseValue]) &&
                depth != maxDepth
              ) {
                object = object[camelCaseValue];
              } else if (object[camelCaseValue] !== undefined) {
                found = object[camelCaseValue];
                return false;
              } else if ($.isPlainObject(object[value]) && depth != maxDepth) {
                object = object[value];
              } else if (object[value] !== undefined) {
                found = object[value];
                return false;
              } else {
                module.error(error.method, query);
                return false;
              }
            });
          }
          if ($.isFunction(found)) {
            response = found.apply(context, passedArguments);
          } else if (found !== undefined) {
            response = found;
          }
          if ($.isArray(returnedValue)) {
            returnedValue.push(response);
          } else if (returnedValue !== undefined) {
            returnedValue = [returnedValue, response];
          } else if (response !== undefined) {
            returnedValue = response;
          }
          return found;
        }
      };

      if (methodInvoked) {
        if (instance === undefined) {
          module.initialize();
        }
        module.invoke(query);
      } else {
        if (instance !== undefined) {
          module.invoke('destroy');
        }
        module.initialize();
      }
    });

    return returnedValue !== undefined ? returnedValue : this;
  };

  $.fn.sidebar.settings = {
    name: 'Sidebar',
    namespace: 'sidebar',

    debug: false,
    verbose: true,
    performance: true,

    transition: 'auto',
    mobileTransition: 'auto',

    defaultTransition: {
      computer: {
        left: 'uncover',
        right: 'uncover',
        top: 'overlay',
        bottom: 'overlay'
      },
      mobile: {
        left: 'uncover',
        right: 'uncover',
        top: 'overlay',
        bottom: 'overlay'
      }
    },

    context: 'body',
    exclusive: false,
    closable: true,
    dimPage: true,
    scrollLock: false,
    returnScroll: false,

    useLegacy: false,
    duration: 500,
    easing: 'easeInOutQuint',

    onChange() {},
    onShow() {},
    onHide() {},

    onHidden() {},
    onVisible() {},

    className: {
      active: 'active',
      animating: 'animating',
      dimmed: 'dimmed',
      pushable: 'pushable',
      pushed: 'pushed',
      right: 'right',
      top: 'top',
      left: 'left',
      bottom: 'bottom',
      visible: 'visible'
    },

    selector: {
      fixed: '.fixed',
      omitted: 'script, link, style, .ui.modal, .ui.dimmer, .ui.nag, .ui.fixed',
      pusher: '.pusher',
      sidebar: '.ui.sidebar'
    },

    error: {
      method: 'The method you called is not defined.',
      pusher:
        'Had to add pusher element. For optimal performance make sure body content is inside a pusher element',
      movedSidebar:
        'Had to move sidebar. For optimal performance make sure sidebar and pusher are direct children of your body tag',
      overlay:
        'The overlay setting is no longer supported, use animation: overlay',
      notFound: 'There were no elements that matched the specified selector'
    }
  };

  // Adds easing
  $.extend($.easing, {
    easeInOutQuint(x, t, b, c, d) {
      if ((t /= d / 2) < 1) return (c / 2) * t * t * t * t * t + b;
      return (c / 2) * ((t -= 2) * t * t * t * t + 2) + b;
    }
  });
})(jQuery, window, document);
